export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  JSON: any;
  JSONObject: any;
  Time: any;
  UUID: any;
  Upload: any;
  Void: any;
};

export type AcademicSession = {
  __typename?: 'AcademicSession';
  active: Scalars['Boolean'];
  dateCreated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateTermEnd: Scalars['DateTime'];
  dateTermStart: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  default: Scalars['Boolean'];
  externalId?: Maybe<ExternalId>;
  id: Scalars['Int'];
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  sisId?: Maybe<Scalars['String']>;
  sourceKind?: Maybe<Scalars['String']>;
  sourceKindId?: Maybe<Scalars['Int']>;
  status: AcademicSessionStatus;
};

export type AcademicSessionCreateInput = {
  dateTermEnd: Scalars['DateTime'];
  dateTermStart: Scalars['DateTime'];
  externalId?: InputMaybe<ExternalIdInput>;
  name?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['Int'];
  sisId?: InputMaybe<Scalars['String']>;
  sourceKind?: InputMaybe<SourceKind>;
};

export enum AcademicSessionOrderField {
  ID = 'ID',
  NAME = 'NAME',
  ORGANIZATION_ID = 'ORGANIZATION_ID',
  SOURCE_ID = 'SOURCE_ID',
  SOURCE_KIND_ID = 'SOURCE_KIND_ID',
}

export enum AcademicSessionStatus {
  CURRENT = 'CURRENT',
  FUTURE = 'FUTURE',
  PREVIOUS = 'PREVIOUS',
}

export type AcademicSessionUpdateInput = {
  dateRemoved?: InputMaybe<Scalars['DateTime']>;
  dateTermEnd?: InputMaybe<Scalars['DateTime']>;
  dateTermStart?: InputMaybe<Scalars['DateTime']>;
  externalId?: InputMaybe<ExternalIdUpdateInput>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  sisId?: InputMaybe<Scalars['String']>;
  sourceKind?: InputMaybe<SourceKind>;
  sourceKindId?: InputMaybe<Scalars['Int']>;
};

export type AcademicSessionWhereInput = {
  externalId?: InputMaybe<ExternalIdInput>;
  id?: InputMaybe<Scalars['Int']>;
};

export type AcademicSessionsDateRangeInput = {
  dateEnd: Scalars['DateTime'];
  dateStart: Scalars['DateTime'];
};

export type AcademicSessionsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<AcademicSessionOrderField>;
};

export type AcademicSessionsUpdateInput = {
  dateRemoved?: InputMaybe<Scalars['DateTime']>;
  dateTermEnd?: InputMaybe<Scalars['DateTime']>;
  dateTermStart?: InputMaybe<Scalars['DateTime']>;
};

export type AcademicSessionsWhereInput = {
  AND?: InputMaybe<Array<AcademicSessionsWhereInput>>;
  OR?: InputMaybe<Array<AcademicSessionsWhereInput>>;
  active?: InputMaybe<Scalars['Boolean']>;
  dateTermRange?: InputMaybe<AcademicSessionsDateRangeInput>;
  default?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
  name_contains?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
  sourceId?: InputMaybe<Array<Scalars['String']>>;
  sourceKind?: InputMaybe<Array<SourceKind>>;
  status?: InputMaybe<AcademicSessionStatus>;
};

export type AccessActivityPageEventCreateInput = {
  activityType: Scalars['String'];
  bookCode: Scalars['String'];
  bookId: Scalars['Int'];
  character: CharacterInput;
  pageId: Scalars['Int'];
  pageLayout: PageLayout;
  pageNumber: Scalars['String'];
  section: ApplicationSection;
  timestamp: Scalars['DateTime'];
};

export type AccessLinkEventCreateInput = {
  link: Scalars['String'];
  route: RouteSource;
  timestamp: Scalars['DateTime'];
};

export type AccessPageEventCreateInput = {
  bookCode: Scalars['String'];
  bookId: Scalars['Int'];
  bookType: BookType;
  character?: InputMaybe<CharacterInput>;
  pageId: Scalars['Int'];
  pageLayout: PageLayout;
  pageNumber: Scalars['String'];
  route: RouteSource;
  section: ApplicationSection;
  timestamp: Scalars['DateTime'];
};

export type AccessResourceEventCreateInput = {
  character?: InputMaybe<CharacterInput>;
  resourceId: Scalars['Int'];
  resourceTitle: Scalars['String'];
  resourceType: Scalars['String'];
  section: ApplicationSection;
  timestamp: Scalars['DateTime'];
};

export type Activity = IActivity & {
  __typename?: 'Activity';
  activityType?: Maybe<ActivityType>;
  activityTypeId: Scalars['Int'];
  book?: Maybe<Book>;
  bookId: Scalars['Int'];
  description: Scalars['String'];
  id: Scalars['Int'];
  title: Scalars['String'];
};

export type ActivityAsset = {
  __typename?: 'ActivityAsset';
  activity?: Maybe<Activity>;
  activityId: Scalars['Int'];
  asset?: Maybe<Asset>;
  assetId: Scalars['Int'];
  id: Scalars['Int'];
  token: Scalars['String'];
};

export type ActivityType = {
  __typename?: 'ActivityType';
  description: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  required: Scalars['Boolean'];
};

export enum ActivityTypeId {
  FIND_THE_LETTER = 'FIND_THE_LETTER',
  FIND_THE_OBJECTS = 'FIND_THE_OBJECTS',
  READ_ALOUD = 'READ_ALOUD',
  READ_STORY = 'READ_STORY',
  SOUND_OUT_WORDS = 'SOUND_OUT_WORDS',
}

export enum ActivityTypeName {
  FIND_THE_LETTER = 'FIND_THE_LETTER',
  FIND_THE_OBJECTS = 'FIND_THE_OBJECTS',
  READ_ALOUD = 'READ_ALOUD',
  READ_STORY = 'READ_STORY',
  SOUND_OUT_WORDS = 'SOUND_OUT_WORDS',
}

export type ActivityWhereInput = {
  book?: InputMaybe<BookWhereInput>;
  id?: InputMaybe<Scalars['Int']>;
};

export type App = {
  __typename?: 'App';
  accessDetails?: Maybe<AppAccessDetails>;
  appProducts: Array<AppProduct>;
  data?: Maybe<Scalars['JSON']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  pliManaged: Scalars['Boolean'];
  products: Array<Product>;
  purchaseDetails?: Maybe<AppPurchaseDetails>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<ProductType>;
};

export type AppAccessDetails = {
  __typename?: 'AppAccessDetails';
  bannerUrl: Scalars['String'];
  iosUrl?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type AppProduct = {
  __typename?: 'AppProduct';
  accessDetails?: Maybe<AppAccessDetails>;
  app?: Maybe<App>;
  appId: Scalars['Int'];
  data?: Maybe<Scalars['JSON']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  pliManaged: Scalars['Boolean'];
  product?: Maybe<Product>;
  productId: Scalars['Int'];
  purchaseDetails?: Maybe<AppPurchaseDetails>;
  title?: Maybe<Scalars['String']>;
};

export type AppPurchaseDetails = {
  __typename?: 'AppPurchaseDetails';
  description?: Maybe<Scalars['String']>;
  salesQuoteUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  webstoreUrl?: Maybe<Scalars['String']>;
};

export enum ApplicationSection {
  LETTER_BOOKS = 'LETTER_BOOKS',
  LETTER_LEARNING = 'LETTER_LEARNING',
  PRACTICE_BOOKS = 'PRACTICE_BOOKS',
  RESOURCES = 'RESOURCES',
}

export enum ApplicationTab {
  GREAT_ALPHABET_PARADE = 'GREAT_ALPHABET_PARADE',
  LETTER_BOOK = 'LETTER_BOOK',
  LETTER_BOOKS = 'LETTER_BOOKS',
  PINNED_RESOURCES = 'PINNED_RESOURCES',
  PRACTICE_BOOK = 'PRACTICE_BOOK',
  RESOURCES = 'RESOURCES',
  TEACHERS_GUIDE = 'TEACHERS_GUIDE',
}

export type Asset = IAsset & {
  __typename?: 'Asset';
  captions?: Maybe<Scalars['JSON']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  narrationCaptions?: Maybe<Scalars['JSON']>;
  narrationSrc?: Maybe<Scalars['String']>;
  narrationVtt?: Maybe<Scalars['String']>;
  src: Scalars['String'];
  type: AssetType;
  vtt?: Maybe<Scalars['String']>;
};

export enum AssetType {
  AUDIO = 'AUDIO',
  IMAGE = 'IMAGE',
  PDF = 'PDF',
  SVG = 'SVG',
  VIDEO = 'VIDEO',
}

export type AssignAvailableLicenseInput = {
  productCurriculum?: InputMaybe<ProductIdentifierInput>;
  replaceExistingProductFamilyLicense?: InputMaybe<Scalars['Boolean']>;
  skipAlreadyLicensed?: InputMaybe<Scalars['Boolean']>;
  skipManualAssignment?: InputMaybe<Scalars['Boolean']>;
  studentId?: InputMaybe<Scalars['Int']>;
  updates?: InputMaybe<LicenseAssignmentUpdateInput>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type AssignAvailableLicenseWhereInput = {
  expiresAfter?: InputMaybe<Scalars['DateTime']>;
  gradeLevel?: InputMaybe<Scalars['String']>;
  ignoreLicenseOverage?: InputMaybe<Scalars['Boolean']>;
  orderItemId?: InputMaybe<Array<Scalars['Int']>>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
  product?: InputMaybe<ProductIdentifierInput>;
  productFamily?: InputMaybe<ProductIdentifierInput>;
};

export enum AssigneeType {
  STUDENT = 'STUDENT',
  USER = 'USER',
}

export type Assignment = {
  __typename?: 'Assignment';
  activities: Array<Activity>;
  assignedToAllGroups: Scalars['Boolean'];
  assignmentActivities: Array<AssignmentActivity>;
  character: Character;
  characterId: Scalars['Int'];
  classroom: Classroom;
  classroomId: Scalars['Int'];
  dateAssigned: Scalars['DateTime'];
  dateCompleted?: Maybe<Scalars['DateTime']>;
  dateStarted?: Maybe<Scalars['DateTime']>;
  groupIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['Int'];
  locale: Locale;
  status?: Maybe<AssignmentStatus>;
  studentIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  students?: Maybe<Array<Student>>;
  title: Scalars['String'];
};

export type AssignmentActivity = {
  __typename?: 'AssignmentActivity';
  activity: Activity;
  activityId: Scalars['Int'];
  assignment: Assignment;
  assignmentId: Scalars['Int'];
  attempts?: Maybe<Array<Attempt>>;
  id: Scalars['Int'];
};

export type AssignmentCreateInput = {
  characterId: Scalars['Int'];
  classroomId: Scalars['Int'];
  groupIds?: InputMaybe<Array<Scalars['Int']>>;
  studentIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type AssignmentDeleteInput = {
  id: Scalars['Int'];
};

export enum AssignmentOrderField {
  ID = 'ID',
}

export type AssignmentSkipInput = {
  id: Scalars['Int'];
  studentIds: Array<Scalars['Int']>;
};

export enum AssignmentStatus {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
  SKIPPED = 'SKIPPED',
}

export type AssignmentUnskipInput = {
  id: Scalars['Int'];
  studentIds: Array<Scalars['Int']>;
};

export type AssignmentUpdateInput = {
  groupIds?: InputMaybe<Array<Scalars['Int']>>;
  id: Scalars['Int'];
  studentIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type AssignmentWhereInput = {
  character?: InputMaybe<CharacterWhereInput>;
  classroomId?: InputMaybe<Scalars['Int']>;
  groupIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  studentIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type AssignmentsCreateInput = {
  characterIds: Array<Scalars['Int']>;
  classroomId: Scalars['Int'];
  groupIds?: InputMaybe<Array<Scalars['Int']>>;
  studentIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type AssignmentsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<AssignmentOrderField>;
};

export type AssignmentsWhereInput = {
  character?: InputMaybe<CharactersWhereInput>;
  classroomId?: InputMaybe<Scalars['Int']>;
  groupIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  studentIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type Attempt = {
  __typename?: 'Attempt';
  assignmentActivity: AssignmentActivity;
  assignmentActivityId: Scalars['Int'];
  dateCompleted?: Maybe<Scalars['DateTime']>;
  dateStarted?: Maybe<Scalars['DateTime']>;
  files?: Maybe<Array<FileUpload>>;
  id: Scalars['Int'];
  status: AttemptStatus;
  studentId: Scalars['Int'];
};

export enum AttemptStatus {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
  SKIPPED = 'SKIPPED',
}

export enum AuthenticationSource {
  CLASS_LINK = 'CLASS_LINK',
  CLEVER = 'CLEVER',
  GOOGLE = 'GOOGLE',
  LOGIN_APP = 'LOGIN_APP',
  LWT = 'LWT',
  SAML = 'SAML',
}

export type BaseSettingCreateInput = {
  appId?: InputMaybe<Scalars['Int']>;
  appName?: InputMaybe<Scalars['String']>;
  productCode?: InputMaybe<Scalars['String']>;
  productCurriculumCode?: InputMaybe<Scalars['String']>;
  productCurriculumId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  setting: Scalars['String'];
  value: Scalars['JSON'];
};

export type BatchMutationResult = {
  __typename?: 'BatchMutationResult';
  count?: Maybe<Scalars['Int']>;
};

export type Book = {
  __typename?: 'Book';
  bookCode: Scalars['String'];
  bookProducts: Array<BookProduct>;
  characters?: Maybe<Array<Character>>;
  edition: Scalars['Int'];
  gradeLevel: GradeLevel;
  id: Scalars['Int'];
  locale: Locale;
  offset?: Maybe<Scalars['Int']>;
  orientation: Orientation;
  pages?: Maybe<Array<Page>>;
  path: Scalars['String'];
  title: Scalars['String'];
  totalPages: Scalars['Int'];
  type: BookType;
  url?: Maybe<Scalars['String']>;
};

export type BookPagesArgs = {
  orderBy?: InputMaybe<PagesOrderInput>;
  where?: InputMaybe<PagesWhereInput>;
};

export type BookContent = {
  __typename?: 'BookContent';
  id: Scalars['Int'];
  pageNumber: Scalars['Int'];
  value: Scalars['String'];
};

export enum BookOrderField {
  ID = 'ID',
  TITLE = 'TITLE',
  TYPE = 'TYPE',
}

export type BookProduct = {
  __typename?: 'BookProduct';
  book: Book;
  bookId: Scalars['Int'];
  id: Scalars['Int'];
  product: Product;
  productId: Scalars['Int'];
};

export enum BookType {
  CLASSROOM_BOOK = 'CLASSROOM_BOOK',
  LETTER_BOOK = 'LETTER_BOOK',
  PRACTICE_BOOK = 'PRACTICE_BOOK',
  TEACHERS_GUIDE = 'TEACHERS_GUIDE',
}

export type BookWhereInput = {
  bookCode?: InputMaybe<Scalars['String']>;
  character?: InputMaybe<CharacterWhereInput>;
  edition?: InputMaybe<Scalars['Int']>;
  gradeLevel?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<BookType>;
};

export type BooksOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<BookOrderField>;
};

export type BooksWhereInput = {
  bookCode?: InputMaybe<Array<Scalars['String']>>;
  character?: InputMaybe<CharactersWhereInput>;
  edition?: InputMaybe<Scalars['Int']>;
  gradeLevel?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  type?: InputMaybe<Array<BookType>>;
};

export type BulkAssignAvailableLicenseInput = {
  expiresAfter?: InputMaybe<Scalars['DateTime']>;
  gradeLevel?: InputMaybe<Scalars['String']>;
  ignoreLicenseOverage?: InputMaybe<Scalars['Boolean']>;
  orderItemId?: InputMaybe<Array<Scalars['Int']>>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
  product?: InputMaybe<ProductIdentifierInput>;
  productCurriculum?: InputMaybe<ProductIdentifierInput>;
  productFamily?: InputMaybe<ProductIdentifierInput>;
  replaceExistingProductFamilyLicense?: InputMaybe<Scalars['Boolean']>;
  skipAlreadyLicensed?: InputMaybe<Scalars['Boolean']>;
  skipManualAssignment?: InputMaybe<Scalars['Boolean']>;
  studentId?: InputMaybe<Scalars['Int']>;
  updates?: InputMaybe<LicenseAssignmentUpdateInput>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type BulkAssignAvailableWhereInput = {
  expiresAfter?: InputMaybe<Scalars['DateTime']>;
  ignoreLicenseOverage?: InputMaybe<Scalars['Boolean']>;
  orderItemId?: InputMaybe<Array<Scalars['Int']>>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
};

export type BulkAssignResult = {
  __typename?: 'BulkAssignResult';
  error?: Maybe<Scalars['String']>;
  license?: Maybe<License>;
  request: LicenseAssignRequest;
};

export type BulkGroupEnrollmentActionGroupCategoryRequest = {
  __typename?: 'BulkGroupEnrollmentActionGroupCategoryRequest';
  classroomId: Scalars['Int'];
  name: Scalars['String'];
};

export type BulkGroupEnrollmentActionGroupRequest = {
  __typename?: 'BulkGroupEnrollmentActionGroupRequest';
  classroomId: Scalars['Int'];
  groupCategory?: Maybe<BulkGroupEnrollmentActionGroupCategoryRequest>;
  name: Scalars['String'];
};

export type BulkGroupEnrollmentActionInput = {
  action: GroupEnrollmentAction;
  group?: InputMaybe<GroupEnrollmentGroupInput>;
  groupId?: InputMaybe<Scalars['Int']>;
  studentId: Scalars['Int'];
};

export type BulkGroupEnrollmentActionRequest = {
  __typename?: 'BulkGroupEnrollmentActionRequest';
  group?: Maybe<BulkGroupEnrollmentActionGroupRequest>;
  groupId?: Maybe<Scalars['Int']>;
  studentId: Scalars['Int'];
};

export type BulkGroupEnrollmentActionResult = {
  __typename?: 'BulkGroupEnrollmentActionResult';
  error?: Maybe<Scalars['String']>;
  groupEnrollment?: Maybe<GroupEnrollment>;
  request: BulkGroupEnrollmentActionRequest;
};

export type BulkLicenseActionInput = {
  action: LicenseAction;
  expiresAfter?: InputMaybe<Scalars['DateTime']>;
  gradeLevel?: InputMaybe<Scalars['String']>;
  ignoreLicenseOverage?: InputMaybe<Scalars['Boolean']>;
  orderItemId?: InputMaybe<Array<Scalars['Int']>>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
  product?: InputMaybe<ProductIdentifierInput>;
  productCurriculum?: InputMaybe<ProductIdentifierInput>;
  productFamily?: InputMaybe<ProductIdentifierInput>;
  replaceExistingProductFamilyLicense?: InputMaybe<Scalars['Boolean']>;
  skipAlreadyLicensed?: InputMaybe<Scalars['Boolean']>;
  skipManualAssignment?: InputMaybe<Scalars['Boolean']>;
  studentId?: InputMaybe<Scalars['Int']>;
  updates?: InputMaybe<LicenseAssignmentUpdateInput>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type BulkLicenseActionResult = {
  __typename?: 'BulkLicenseActionResult';
  error?: Maybe<Scalars['String']>;
  licenses?: Maybe<Array<License>>;
  request: LicenseActionRequest;
};

export type BulkLicenseActionWhereInput = {
  expiresAfter?: InputMaybe<Scalars['DateTime']>;
  ignoreLicenseOverage?: InputMaybe<Scalars['Boolean']>;
  orderItemId?: InputMaybe<Array<Scalars['Int']>>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
};

export type Character = {
  __typename?: 'Character';
  character: Scalars['String'];
  characterCase?: Maybe<CharacterCase>;
  characterType: CharacterType;
  id: Scalars['Int'];
};

export enum CharacterCase {
  LOWERCASE = 'LOWERCASE',
  UPPERCASE = 'UPPERCASE',
}

export type CharacterInput = {
  character: Scalars['String'];
  characterCase?: InputMaybe<CharacterCase>;
  characterId: Scalars['Int'];
  characterType: CharacterType;
};

export enum CharacterOrderField {
  ID = 'ID',
  TITLE = 'TITLE',
  TYPE = 'TYPE',
}

export type CharacterProgress = {
  __typename?: 'CharacterProgress';
  activityCompletedCount: Scalars['Int'];
  activitySkippedCount: Scalars['Int'];
  activityTotalCount: Scalars['Int'];
  bookReadCount: Scalars['Int'];
  character?: Maybe<Character>;
  characterId: Scalars['Int'];
  readingLogCount: Scalars['Int'];
};

export enum CharacterType {
  CURSIVE = 'CURSIVE',
  NUMBER = 'NUMBER',
  PRINT = 'PRINT',
}

export type CharacterWhereInput = {
  character?: InputMaybe<Scalars['String']>;
  characterCase?: InputMaybe<CharacterCase>;
  characterType?: InputMaybe<CharacterType>;
  id?: InputMaybe<Scalars['Int']>;
};

export type CharactersWhereInput = {
  character?: InputMaybe<Array<Scalars['String']>>;
  characterCase?: InputMaybe<CharacterCase>;
  characterType?: InputMaybe<CharacterType>;
  id?: InputMaybe<Array<Scalars['Int']>>;
};

export type Classroom = {
  __typename?: 'Classroom';
  academicSession?: Maybe<AcademicSession>;
  academicSessionId?: Maybe<Scalars['Int']>;
  color: Scalars['String'];
  dateArchived?: Maybe<Scalars['DateTime']>;
  dateCreated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  externalId?: Maybe<ExternalId>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['Int'];
  licenseUsage?: Maybe<Array<ClassroomLicenseUsage>>;
  loginType: StudentLoginType;
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  settings?: Maybe<Array<ClassroomSetting>>;
  sisId?: Maybe<Scalars['String']>;
  stats: ClassroomStats;
  status?: Maybe<ClassroomStatus>;
  studentCount: Scalars['Int'];
  students?: Maybe<Array<Student>>;
  users?: Maybe<Array<UserClassroomEnrollment>>;
};

export type ClassroomGroupsArgs = {
  orderBy?: InputMaybe<GroupsOrderInput>;
  where?: InputMaybe<GroupsWhereInput>;
};

export type ClassroomLicenseUsageArgs = {
  where?: InputMaybe<LicenseUsageWhereInput>;
};

export type ClassroomSettingsArgs = {
  orderBy?: InputMaybe<ClassroomSettingsOrderInput>;
  where?: InputMaybe<ClassroomSettingsWhereInput>;
};

export type ClassroomUsersArgs = {
  where?: InputMaybe<UsersWhereInput>;
};

export type ClassroomCreateInput = {
  academicSessionId?: InputMaybe<Scalars['Int']>;
  color?: InputMaybe<Scalars['String']>;
  dateArchived?: InputMaybe<Scalars['DateTime']>;
  dateRemoved?: InputMaybe<Scalars['DateTime']>;
  externalId?: InputMaybe<ExternalIdInput>;
  loginType?: InputMaybe<StudentLoginType>;
  name: Scalars['String'];
  organizationId: Scalars['Int'];
  settings?: InputMaybe<Array<BaseSettingCreateInput>>;
  sisId?: InputMaybe<Scalars['String']>;
  studentEnrollments?: InputMaybe<Array<Scalars['Int']>>;
  students?: InputMaybe<Array<StudentCreateInput>>;
  userEnrollments?: InputMaybe<Array<UserEnrollmentInput>>;
};

export type ClassroomLicenseUsage = {
  __typename?: 'ClassroomLicenseUsage';
  assignedCount: Scalars['Int'];
  product: Product;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productId: Scalars['Int'];
};

export enum ClassroomOrderField {
  DATE_ARCHIVED = 'DATE_ARCHIVED',
  DATE_CREATED = 'DATE_CREATED',
  DATE_REMOVED = 'DATE_REMOVED',
  ID = 'ID',
  NAME = 'NAME',
  ORGANIZATION_ID = 'ORGANIZATION_ID',
  SOURCE_ID = 'SOURCE_ID',
  SOURCE_KIND_ID = 'SOURCE_KIND_ID',
}

export type ClassroomPrivilege = {
  __typename?: 'ClassroomPrivilege';
  displayName: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export enum ClassroomPrivilegeOrderField {
  DISPLAY_NAME = 'DISPLAY_NAME',
  ID = 'ID',
  NAME = 'NAME',
}

export type ClassroomPrivilegeWhereInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type ClassroomPrivilegesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<ClassroomPrivilegeOrderField>;
};

export type ClassroomPrivilegesWhereInput = {
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
};

export type ClassroomRole = {
  __typename?: 'ClassroomRole';
  app?: Maybe<App>;
  appId?: Maybe<Scalars['Int']>;
  classification: ClassroomRoleClassification;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  displayName: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  privileges?: Maybe<Array<Maybe<ClassroomPrivilege>>>;
};

export enum ClassroomRoleClassification {
  COEDUCATOR = 'COEDUCATOR',
  EDUCATOR = 'EDUCATOR',
}

export enum ClassroomRoleOrderField {
  APP = 'APP',
  DISPLAY_NAME = 'DISPLAY_NAME',
  ID = 'ID',
  NAME = 'NAME',
  ORGANIZATION = 'ORGANIZATION',
}

export type ClassroomRoleWhereInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type ClassroomRolesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<ClassroomRoleOrderField>;
};

export type ClassroomRolesWhereInput = {
  appId?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
};

export type ClassroomSetting = {
  __typename?: 'ClassroomSetting';
  app: App;
  appId: Scalars['Int'];
  classroom: Classroom;
  classroomId: Scalars['Int'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  id: Scalars['Int'];
  product?: Maybe<Product>;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  setting: Scalars['String'];
  value: Scalars['JSON'];
};

export type ClassroomSettingCreateInput = {
  appId?: InputMaybe<Scalars['Int']>;
  appName?: InputMaybe<Scalars['String']>;
  classroomId: Scalars['Int'];
  productCode?: InputMaybe<Scalars['String']>;
  productCurriculumCode?: InputMaybe<Scalars['String']>;
  productCurriculumId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  setting: Scalars['String'];
  value: Scalars['JSON'];
};

export enum ClassroomSettingOrderField {
  APP_ID = 'APP_ID',
  CLASSROOM_ID = 'CLASSROOM_ID',
  PRODUCT_CURRICULUM_ID = 'PRODUCT_CURRICULUM_ID',
  PRODUCT_ID = 'PRODUCT_ID',
  SETTING = 'SETTING',
}

export type ClassroomSettingUpdateInput = {
  appId?: InputMaybe<Scalars['Int']>;
  classroomId?: InputMaybe<Scalars['Int']>;
  setting?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type ClassroomSettingWhereInput = {
  appId?: InputMaybe<Scalars['Int']>;
  appName?: InputMaybe<Scalars['String']>;
  classroomId: Scalars['Int'];
  productCode?: InputMaybe<Scalars['String']>;
  productCurriculumCode?: InputMaybe<Scalars['String']>;
  productCurriculumId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  setting: Scalars['String'];
};

export type ClassroomSettingsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<ClassroomSettingOrderField>;
};

export type ClassroomSettingsUpdateInput = {
  appId?: InputMaybe<Scalars['Int']>;
  classroomId?: InputMaybe<Scalars['Int']>;
  setting?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type ClassroomSettingsWhereInput = {
  appId?: InputMaybe<Array<Scalars['Int']>>;
  appName?: InputMaybe<Array<Scalars['String']>>;
  classroomId?: InputMaybe<Array<Scalars['Int']>>;
  productCode?: InputMaybe<Array<Scalars['String']>>;
  productCurriculumCode?: InputMaybe<Array<Scalars['String']>>;
  productCurriculumId?: InputMaybe<Array<Scalars['Int']>>;
  productId?: InputMaybe<Array<Scalars['Int']>>;
  setting?: InputMaybe<Array<Scalars['String']>>;
};

export type ClassroomStats = {
  __typename?: 'ClassroomStats';
  studentCount: Scalars['Int'];
  userCount: Scalars['Int'];
};

export enum ClassroomStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  REMOVED = 'REMOVED',
}

export type ClassroomUpdateInput = {
  academicSessionId?: InputMaybe<Scalars['Int']>;
  color?: InputMaybe<Scalars['String']>;
  dateArchived?: InputMaybe<Scalars['DateTime']>;
  dateRemoved?: InputMaybe<Scalars['DateTime']>;
  externalId?: InputMaybe<ExternalIdUpdateInput>;
  loginType?: InputMaybe<StudentLoginType>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  sisId?: InputMaybe<Scalars['String']>;
  userEnrollments?: InputMaybe<Array<UserEnrollmentInput>>;
};

export type ClassroomWhereInput = {
  externalId?: InputMaybe<ExternalIdInput>;
  id?: InputMaybe<Scalars['Int']>;
};

export type ClassroomsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<ClassroomOrderField>;
};

export type ClassroomsUpdateInput = {
  academicSessionId?: InputMaybe<Scalars['Int']>;
  dateArchived?: InputMaybe<Scalars['DateTime']>;
  dateRemoved?: InputMaybe<Scalars['DateTime']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

export type ClassroomsWhereInput = {
  AND?: InputMaybe<Array<ClassroomsWhereInput>>;
  OR?: InputMaybe<Array<ClassroomsWhereInput>>;
  academicSessionId?: InputMaybe<Array<Scalars['Int']>>;
  archived?: InputMaybe<Scalars['Boolean']>;
  coEducator?: InputMaybe<UsersWhereInput>;
  educator?: InputMaybe<UsersWhereInput>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  includeRemoved?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Array<Scalars['String']>>;
  name_contains?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationsWhereInput>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
  sourceId?: InputMaybe<Array<Scalars['String']>>;
  sourceKind?: InputMaybe<Array<SourceKind>>;
  status?: InputMaybe<Array<ClassroomStatus>>;
};

export enum ComponentType {
  BUTTON = 'BUTTON',
  CHECKBOX = 'CHECKBOX',
}

export type Contact = {
  __typename?: 'Contact';
  dateCreated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  email: Scalars['String'];
  externalId?: Maybe<ExternalId>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  sisId?: Maybe<Scalars['String']>;
  students?: Maybe<Array<Student>>;
};

export type ContactInput = {
  email: Scalars['String'];
  externalId?: InputMaybe<ExternalIdInput>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  sisId?: InputMaybe<Scalars['String']>;
  studentIds?: InputMaybe<Array<Scalars['Int']>>;
};

export enum ContactOrderField {
  ID = 'ID',
  SOURCE_ID = 'SOURCE_ID',
  SOURCE_KIND_ID = 'SOURCE_KIND_ID',
}

export type ContactStudentRemoveInput = {
  contactId: Scalars['Int'];
  studentId?: InputMaybe<Array<Scalars['Int']>>;
};

export type ContactUpdateInput = {
  email?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<ExternalIdUpdateInput>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  sisId?: InputMaybe<Scalars['String']>;
};

export type ContactWhereInput = {
  externalId?: InputMaybe<ExternalIdInput>;
  id?: InputMaybe<Scalars['Int']>;
};

export type ContactsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<ContactOrderField>;
};

export type ContactsWhereInput = {
  AND?: InputMaybe<Array<ContactsWhereInput>>;
  OR?: InputMaybe<Array<ContactsWhereInput>>;
  email?: InputMaybe<Array<Scalars['String']>>;
  email_contains?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Array<Scalars['String']>>;
  firstName_contains?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  lastName?: InputMaybe<Array<Scalars['String']>>;
  lastName_contains?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Array<Scalars['String']>>;
  sourceKind?: InputMaybe<Array<SourceKind>>;
};

export type CreateEntityLicenseAssignInput = {
  productCode?: InputMaybe<Scalars['String']>;
  productCurriculumCode?: InputMaybe<Scalars['String']>;
  productCurriculumId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
};

export type CustomTeachingOrder = {
  __typename?: 'CustomTeachingOrder';
  active: Scalars['Boolean'];
  characters: Array<Character>;
  id: Scalars['Int'];
  locale: Locale;
  name: Scalars['String'];
  ownerId: Scalars['Int'];
};

export type CustomTeachingOrderCreateInput = {
  characterIds: Array<Scalars['Int']>;
};

export type CustomTeachingOrderDeleteInput = {
  id: Scalars['Int'];
};

export type CustomTeachingOrderUpdateInput = {
  characterIds?: InputMaybe<Array<Scalars['Int']>>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
};

export type CustomTeachingOrderWhereInput = {
  id: Scalars['Int'];
};

export type DefaultGroupSetting = {
  __typename?: 'DefaultGroupSetting';
  gradeLevels: Array<Scalars['String']>;
  group: GroupCreate;
  productCodes: Array<Scalars['String']>;
};

export type Enrollment = {
  __typename?: 'Enrollment';
  classroom: Classroom;
  classroomRole?: Maybe<ClassroomRole>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  id: Scalars['Int'];
  removedDate?: Maybe<Scalars['DateTime']>;
  student?: Maybe<Student>;
  user?: Maybe<User>;
};

export enum EnrollmentOrderField {
  CLASSROOM_ROLE = 'CLASSROOM_ROLE',
  CLASSROOM_ROLE_ID = 'CLASSROOM_ROLE_ID',
  STUDENT_ID = 'STUDENT_ID',
  USER_ID = 'USER_ID',
}

export type EnrollmentWhereInput = {
  id: Scalars['Int'];
};

export type EnrollmentsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<EnrollmentOrderField>;
};

export type EnrollmentsWhereInput = {
  classroomId?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  classroomRole?: InputMaybe<Array<InputMaybe<UserRole>>>;
  classroomRoleId?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  studentId?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  userId?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type ExternalId = {
  __typename?: 'ExternalId';
  sourceId: Scalars['String'];
  sourceKind: SourceKind;
  sourceKindId: Scalars['Int'];
};

export type ExternalIdInput = {
  sourceId: Scalars['String'];
  sourceKind: SourceKind;
};

export type ExternalIdUpdateInput = {
  sourceId?: InputMaybe<Scalars['String']>;
  sourceKind?: InputMaybe<SourceKind>;
};

export type Favorite = {
  __typename?: 'Favorite';
  id: Scalars['Int'];
  page?: Maybe<Page>;
  pageId?: Maybe<Scalars['Int']>;
  resource?: Maybe<Resource>;
  resourceId?: Maybe<Scalars['Int']>;
  user: User;
  userId: Scalars['Int'];
};

export type FavoriteCreateInput = {
  pageId?: InputMaybe<Scalars['Int']>;
  resourceId?: InputMaybe<Scalars['Int']>;
};

export type FavoriteDeleteInput = {
  id?: InputMaybe<Scalars['Int']>;
  pageId?: InputMaybe<Scalars['Int']>;
  resourceId?: InputMaybe<Scalars['Int']>;
};

export enum FavoriteOrderField {
  ID = 'ID',
  PAGE_ID = 'PAGE_ID',
  RESOURCE_ID = 'RESOURCE_ID',
}

export type FavoriteUpdateInput = {
  id: Scalars['Int'];
  pageId?: InputMaybe<Scalars['Int']>;
  resourceId?: InputMaybe<Scalars['Int']>;
};

export type FavoritesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<FavoriteOrderField>;
};

export type FavoritesWhereInput = {
  id?: InputMaybe<Array<Scalars['Int']>>;
  pageId?: InputMaybe<Array<Scalars['Int']>>;
  resourceId?: InputMaybe<Array<Scalars['Int']>>;
};

export type FeatureToggle = {
  __typename?: 'FeatureToggle';
  app: App;
  appId: Scalars['Int'];
  data?: Maybe<Scalars['JSON']>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type FeatureToggleInput = {
  appId: Scalars['Int'];
  data?: InputMaybe<Scalars['JSON']>;
  enabled: Scalars['Boolean'];
  name: Scalars['String'];
};

export enum FeatureToggleOrderField {
  APP_ID = 'APP_ID',
  DATE_CREATED = 'DATE_CREATED',
  ENABLED = 'ENABLED',
  ID = 'ID',
  NAME = 'NAME',
}

export type FeatureToggleUpdateInput = {
  appId?: InputMaybe<Scalars['Int']>;
  data?: InputMaybe<Scalars['JSON']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FeatureToggleWhereInput = {
  appId?: InputMaybe<Scalars['Int']>;
  appName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type FeatureTogglesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<FeatureToggleOrderField>;
};

export type FeatureTogglesWhereInput = {
  appId?: InputMaybe<Array<Scalars['Int']>>;
  appName?: InputMaybe<Array<Scalars['String']>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
};

export type FileUpload = {
  __typename?: 'FileUpload';
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  mimeType: MimeType;
  originalFilename: Scalars['String'];
  signedUrl: Scalars['String'];
  size: Scalars['Int'];
  url: Scalars['String'];
};

export type FileUploadInput = {
  description?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
};

export type FindAvailableLicenseWhereInput = {
  expiresAfter?: InputMaybe<Scalars['DateTime']>;
  gradeLevel?: InputMaybe<Scalars['String']>;
  ignoreLicenseOverage?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderItemId?: InputMaybe<Array<Scalars['Int']>>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
  product?: InputMaybe<ProductIdentifierInput>;
  productFamily?: InputMaybe<ProductIdentifierInput>;
};

export type FindTheLetterActivity = IActivity & {
  __typename?: 'FindTheLetterActivity';
  activityType?: Maybe<ActivityType>;
  activityTypeId: Scalars['Int'];
  book?: Maybe<Book>;
  bookId: Scalars['Int'];
  description: Scalars['String'];
  id: Scalars['Int'];
  pages: Array<FindTheLetterPage>;
  sound: Asset;
  title: Scalars['String'];
};

export type FindTheLetterAsset = IAsset & {
  __typename?: 'FindTheLetterAsset';
  captions?: Maybe<Scalars['JSON']>;
  description: Scalars['String'];
  id: Scalars['Int'];
  narrationCaptions?: Maybe<Scalars['JSON']>;
  narrationSrc?: Maybe<Scalars['String']>;
  narrationVtt?: Maybe<Scalars['String']>;
  occurrences?: Maybe<Scalars['Int']>;
  spreadLayout?: Maybe<Scalars['Boolean']>;
  src: Scalars['String'];
  type: AssetType;
  vtt?: Maybe<Scalars['String']>;
};

export type FindTheLetterPage = {
  __typename?: 'FindTheLetterPage';
  contents?: Maybe<FindTheLetterAsset>;
  page: Page;
  pageId: Scalars['Int'];
  png?: Maybe<FindTheLetterAsset>;
};

export type FindTheObjectsActivity = IActivity & {
  __typename?: 'FindTheObjectsActivity';
  activityType?: Maybe<ActivityType>;
  activityTypeId: Scalars['Int'];
  book?: Maybe<Book>;
  bookId: Scalars['Int'];
  description: Scalars['String'];
  id: Scalars['Int'];
  pages: Array<FindTheObjectsPage>;
  title: Scalars['String'];
};

export type FindTheObjectsAsset = IAsset & {
  __typename?: 'FindTheObjectsAsset';
  animation: Scalars['Boolean'];
  captions?: Maybe<Scalars['JSON']>;
  description: Scalars['String'];
  id: Scalars['Int'];
  narrationCaptions?: Maybe<Scalars['JSON']>;
  narrationSrc?: Maybe<Scalars['String']>;
  narrationVtt?: Maybe<Scalars['String']>;
  occurrences: Scalars['Int'];
  src: Scalars['String'];
  type: AssetType;
  vtt?: Maybe<Scalars['String']>;
};

export type FindTheObjectsPage = {
  __typename?: 'FindTheObjectsPage';
  animation?: Maybe<Asset>;
  contents?: Maybe<Asset>;
  objects?: Maybe<Array<FindTheObjectsAsset>>;
  page: Page;
  pageId: Scalars['Int'];
  svg?: Maybe<Asset>;
};

export enum GradeLevel {
  FIFTH = 'FIFTH',
  FIRST = 'FIRST',
  FOURTH = 'FOURTH',
  K = 'K',
  PK = 'PK',
  SECOND = 'SECOND',
  THIRD = 'THIRD',
  TK = 'TK',
}

export type Group = {
  __typename?: 'Group';
  app: App;
  appId: Scalars['Int'];
  classroom: Classroom;
  classroomId: Scalars['Int'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  groupCategory: GroupCategory;
  groupCategoryId: Scalars['Int'];
  groupEnrollments: Array<Maybe<GroupEnrollment>>;
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type GroupCategoriesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<GroupCategoryOrderField>;
};

export type GroupCategoriesWhereInput = {
  appId?: InputMaybe<Array<Scalars['Int']>>;
  classroomId?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
};

export type GroupCategory = {
  __typename?: 'GroupCategory';
  app: App;
  appId: Scalars['Int'];
  classroom: Classroom;
  classroomId: Scalars['Int'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  groups: Array<Maybe<Group>>;
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type GroupCategoryCreate = {
  __typename?: 'GroupCategoryCreate';
  appId: Scalars['Int'];
  id?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type GroupCategoryCreateInput = {
  appId: Scalars['Int'];
  classroomId: Scalars['Int'];
  name: Scalars['String'];
};

export enum GroupCategoryOrderField {
  CLASSROOM_ID = 'CLASSROOM_ID',
  ID = 'ID',
  NAME = 'NAME',
}

export type GroupCategoryUpsertInput = {
  appId?: InputMaybe<Scalars['Int']>;
  classroomId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type GroupCategoryWhereInput = {
  appId?: InputMaybe<Scalars['Int']>;
  classroomId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type GroupCreate = {
  __typename?: 'GroupCreate';
  appId: Scalars['Int'];
  groupCategory?: Maybe<GroupCategoryCreate>;
  id?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type GroupCreateInput = {
  appId: Scalars['Int'];
  classroomId: Scalars['Int'];
  groupCategory: GroupCategoryCreateInput;
  name: Scalars['String'];
};

export type GroupEnrollment = {
  __typename?: 'GroupEnrollment';
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  group?: Maybe<Group>;
  groupId: Scalars['Int'];
  id: Scalars['Int'];
  student?: Maybe<Student>;
  studentId: Scalars['Int'];
};

export enum GroupEnrollmentAction {
  ENROLL = 'ENROLL',
  UNENROLL = 'UNENROLL',
}

export type GroupEnrollmentGroupCategoryInput = {
  appId: Scalars['Int'];
  classroomId: Scalars['Int'];
  name: Scalars['String'];
};

export type GroupEnrollmentGroupInput = {
  appId: Scalars['Int'];
  classroomId: Scalars['Int'];
  groupCategory?: InputMaybe<GroupEnrollmentGroupCategoryInput>;
  name: Scalars['String'];
};

export enum GroupEnrollmentOrderField {
  GROUP_ID = 'GROUP_ID',
  ID = 'ID',
  STUDENT_ID = 'STUDENT_ID',
}

export type GroupEnrollmentWhereInput = {
  groupId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  studentId?: InputMaybe<Scalars['Int']>;
};

export type GroupEnrollmentsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<GroupEnrollmentOrderField>;
};

export type GroupEnrollmentsWhereInput = {
  groupId?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  studentId?: InputMaybe<Array<Scalars['Int']>>;
};

export enum GroupOrderField {
  CLASSROOM_ID = 'CLASSROOM_ID',
  GROUP_CATEGORY_ID = 'GROUP_CATEGORY_ID',
  ID = 'ID',
  NAME = 'NAME',
}

export type GroupUnenrollmentInput = {
  groupId: Scalars['Int'];
  studentId: Scalars['Int'];
};

export type GroupUpdateInput = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type GroupUpsertInput = {
  appId?: InputMaybe<Scalars['Int']>;
  classroomId?: InputMaybe<Scalars['Int']>;
  groupCategory?: InputMaybe<GroupCategoryUpsertInput>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type GroupWhereInput = {
  appId?: InputMaybe<Scalars['Int']>;
  classroomId?: InputMaybe<Scalars['Int']>;
  groupCategoryId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type GroupsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<GroupOrderField>;
};

export type GroupsWhereInput = {
  appId?: InputMaybe<Array<Scalars['Int']>>;
  classroomId?: InputMaybe<Array<Scalars['Int']>>;
  groupCategoryId?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
};

export type IActivity = {
  activityType?: Maybe<ActivityType>;
  activityTypeId: Scalars['Int'];
  book?: Maybe<Book>;
  bookId: Scalars['Int'];
  description: Scalars['String'];
  id: Scalars['Int'];
  title: Scalars['String'];
};

export type IAsset = {
  captions?: Maybe<Scalars['JSON']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  narrationCaptions?: Maybe<Scalars['JSON']>;
  narrationSrc?: Maybe<Scalars['String']>;
  narrationVtt?: Maybe<Scalars['String']>;
  src: Scalars['String'];
  type: AssetType;
  vtt?: Maybe<Scalars['String']>;
};

export type License = {
  __typename?: 'License';
  dateCreated: Scalars['DateTime'];
  dateExpiration: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  dateUpdatedAssignment?: Maybe<Scalars['DateTime']>;
  dateUsed?: Maybe<Scalars['DateTime']>;
  expired: Scalars['Boolean'];
  id: Scalars['Int'];
  licenseType: LicenseType;
  licenseTypeId: Scalars['Int'];
  manualAssignment?: Maybe<Scalars['Boolean']>;
  orderItem?: Maybe<OrderItem>;
  orderItemId: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  product?: Maybe<Product>;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productId: Scalars['Int'];
  siteLicense?: Maybe<SiteLicense>;
  siteLicenseId?: Maybe<Scalars['Int']>;
  student?: Maybe<Student>;
  studentId?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']>;
};

export enum LicenseAction {
  ASSIGN = 'ASSIGN',
  UNASSIGN = 'UNASSIGN',
}

export type LicenseActionRequest = {
  __typename?: 'LicenseActionRequest';
  action?: Maybe<LicenseAction>;
  gradeLevel?: Maybe<Scalars['String']>;
  orderItemId?: Maybe<Array<Scalars['Int']>>;
  productCode?: Maybe<Scalars['String']>;
  productCurriculumCode?: Maybe<Scalars['String']>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  replaceExistingProductFamilyLicense?: Maybe<Scalars['Boolean']>;
  skipAlreadyLicensed?: Maybe<Scalars['Boolean']>;
  skipManualAssignment?: Maybe<Scalars['Boolean']>;
  studentId?: Maybe<Scalars['Int']>;
  updates?: Maybe<LicenseAssignUpdates>;
  userId?: Maybe<Scalars['Int']>;
};

export type LicenseAssignInput = {
  productCurriculum?: InputMaybe<ProductIdentifierInput>;
  studentId?: InputMaybe<Scalars['Int']>;
  updates?: InputMaybe<LicenseAssignmentUpdateInput>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type LicenseAssignRequest = {
  __typename?: 'LicenseAssignRequest';
  gradeLevel?: Maybe<Scalars['String']>;
  orderItemId?: Maybe<Array<Scalars['Int']>>;
  productCode?: Maybe<Scalars['String']>;
  productCurriculumCode?: Maybe<Scalars['String']>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  replaceExistingProductFamilyLicense?: Maybe<Scalars['Boolean']>;
  skipAlreadyLicensed?: Maybe<Scalars['Boolean']>;
  skipManualAssignment?: Maybe<Scalars['Boolean']>;
  studentId?: Maybe<Scalars['Int']>;
  updates?: Maybe<LicenseAssignUpdates>;
  userId?: Maybe<Scalars['Int']>;
};

export type LicenseAssignUpdates = {
  __typename?: 'LicenseAssignUpdates';
  dateExpiration?: Maybe<Scalars['DateTime']>;
  dateUsed?: Maybe<Scalars['DateTime']>;
  organizationId?: Maybe<Scalars['Int']>;
};

export type LicenseAssignmentUpdateInput = {
  dateExpiration?: InputMaybe<Scalars['DateTime']>;
  dateUsed?: InputMaybe<Scalars['DateTime']>;
  manualAssignment?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

export type LicenseExpirationInput = {
  gracePeriodEndDate: Scalars['DateTime'];
  unlockDate: Scalars['DateTime'];
};

export enum LicenseOrderField {
  DATE_CREATED = 'DATE_CREATED',
  DATE_EXPIRATION = 'DATE_EXPIRATION',
  DATE_UPDATED = 'DATE_UPDATED',
  DATE_UPDATED_ASSIGNMENT = 'DATE_UPDATED_ASSIGNMENT',
  ID = 'ID',
  MANUAL_ASSIGNMENT = 'MANUAL_ASSIGNMENT',
  ORDER_ITEM_ID = 'ORDER_ITEM_ID',
  ORGANIZATION_ID = 'ORGANIZATION_ID',
  PRODUCT_CURRICULUM_ID = 'PRODUCT_CURRICULUM_ID',
  PRODUCT_ID = 'PRODUCT_ID',
  STUDENT_ID = 'STUDENT_ID',
  USER_ID = 'USER_ID',
}

export enum LicenseStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  REMOVED = 'REMOVED',
}

export enum LicenseType {
  ADD_ON = 'ADD_ON',
  EMPLOYEE = 'EMPLOYEE',
  FULL = 'FULL',
  MULTI_YEAR = 'MULTI_YEAR',
  OVERAGE = 'OVERAGE',
  PRORATED = 'PRORATED',
  RENEWAL = 'RENEWAL',
  TRIAL = 'TRIAL',
  WORKSHOP = 'WORKSHOP',
}

export type LicenseUpdateInput = {
  dateExpiration?: InputMaybe<Scalars['DateTime']>;
  expiration?: InputMaybe<LicenseExpirationInput>;
  orderItemId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
};

export type LicenseUsageWhereInput = {
  product?: InputMaybe<Array<ProductIdentifierInput>>;
  productCurriculum?: InputMaybe<Array<ProductIdentifierInput>>;
  productFamily?: InputMaybe<Array<ProductIdentifierInput>>;
};

export type LicenseWhereInput = {
  id: Scalars['Int'];
  includeRemoved?: InputMaybe<Scalars['Boolean']>;
};

export type LicensesMastercodeWhereInput = {
  code?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
};

export type LicensesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<LicenseOrderField>;
};

export type LicensesOrderWhereInput = {
  AND?: InputMaybe<Array<LicensesOrderWhereInput>>;
  OR?: InputMaybe<Array<LicensesOrderWhereInput>>;
  ecmsOrderNumber?: InputMaybe<Array<Scalars['String']>>;
  ecmsOrderNumber_contains?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  orderNumber?: InputMaybe<Array<Scalars['String']>>;
  orderNumber_contains?: InputMaybe<Scalars['String']>;
};

export type LicensesOrganizationWhereInput = {
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
  name_contains?: InputMaybe<Scalars['String']>;
};

export type LicensesWhereInput = {
  AND?: InputMaybe<Array<LicensesWhereInput>>;
  OR?: InputMaybe<Array<LicensesWhereInput>>;
  assigned?: InputMaybe<Scalars['Boolean']>;
  assigneeType?: InputMaybe<AssigneeType>;
  expired?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  includeRemoved?: InputMaybe<Scalars['Boolean']>;
  licenseType?: InputMaybe<Array<LicenseType>>;
  manualAssignment?: InputMaybe<Scalars['Boolean']>;
  mastercode?: InputMaybe<LicensesMastercodeWhereInput>;
  order?: InputMaybe<LicensesOrderWhereInput>;
  orderItemId?: InputMaybe<Array<Scalars['Int']>>;
  organization?: InputMaybe<LicensesOrganizationWhereInput>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
  product?: InputMaybe<Array<ProductIdentifierInput>>;
  productCurriculum?: InputMaybe<Array<ProductIdentifierInput>>;
  productFamily?: InputMaybe<Array<ProductIdentifierInput>>;
  siteLicenseId?: InputMaybe<Array<Scalars['Int']>>;
  status?: InputMaybe<Array<LicenseStatus>>;
  studentId?: InputMaybe<Array<Scalars['Int']>>;
  userId?: InputMaybe<Array<Scalars['Int']>>;
};

export enum Locale {
  EN_US = 'EN_US',
  ES_US = 'ES_US',
}

export type LogApiErrorInput = {
  body?: InputMaybe<Scalars['JSON']>;
  data?: InputMaybe<Scalars['JSON']>;
  method: Scalars['String'];
  params?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<Scalars['Int']>;
  timestamp: Scalars['DateTime'];
  url: Scalars['String'];
};

export type LogApplicationErrorInput = {
  context?: InputMaybe<Scalars['JSON']>;
  message: Scalars['String'];
  stack?: InputMaybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
};

export type LoginSuccessEventCreateInput = {
  authenticationSource: AuthenticationSource;
  classroomId?: InputMaybe<Scalars['Int']>;
  sessionId: Scalars['String'];
  timestamp: Scalars['DateTime'];
};

export type Mastercode = {
  __typename?: 'Mastercode';
  code: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  dateExpired?: Maybe<Scalars['DateTime']>;
  dateGracePeriodEnd: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateScheduledUnlock?: Maybe<Scalars['DateTime']>;
  dateUnlocked?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  id: Scalars['Int'];
  orderItems?: Maybe<Array<OrderItem>>;
  ownerEmail?: Maybe<Scalars['String']>;
  parentMastercode?: Maybe<Mastercode>;
  parentMastercodeId?: Maybe<Scalars['Int']>;
  status?: Maybe<MastercodeStatus>;
  transferHistory?: Maybe<Array<MastercodeTransferHistory>>;
};

export enum MastercodeOrderField {
  CODE = 'CODE',
  DATE_CREATED = 'DATE_CREATED',
  DATE_REMOVED = 'DATE_REMOVED',
  DATE_SCHEDULED_UNLOCK = 'DATE_SCHEDULED_UNLOCK',
  DATE_UNLOCKED = 'DATE_UNLOCKED',
  ID = 'ID',
  OWNER_EMAIL = 'OWNER_EMAIL',
}

export type MastercodeOrderItemsWhereInput = {
  id?: InputMaybe<Array<Scalars['Int']>>;
  licenseType?: InputMaybe<Array<LicenseType>>;
  licenseTypeId?: InputMaybe<Array<Scalars['Int']>>;
  trial?: InputMaybe<Scalars['Boolean']>;
};

export type MastercodeOrdersWhereInput = {
  id?: InputMaybe<Array<Scalars['Int']>>;
  orderNumber?: InputMaybe<Array<Scalars['String']>>;
  psrentOrderId?: InputMaybe<Array<Scalars['Int']>>;
  type?: InputMaybe<Array<Scalars['String']>>;
  userId?: InputMaybe<Array<Scalars['Int']>>;
};

export type MastercodeOrganizationsWhereInput = {
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
  name_contains?: InputMaybe<Scalars['String']>;
};

export enum MastercodeStatus {
  EXPIRED = 'EXPIRED',
  LOCKED = 'LOCKED',
  REMOVED = 'REMOVED',
  SCHEDULED = 'SCHEDULED',
  UNLOCKED = 'UNLOCKED',
}

export type MastercodeTransferHistoriesWhereInput = {
  id?: InputMaybe<Array<Scalars['Int']>>;
  mastercodeId?: InputMaybe<Array<Scalars['Int']>>;
  newOwnerEmail?: InputMaybe<Array<Scalars['String']>>;
  previousOwnerEmail?: InputMaybe<Array<Scalars['String']>>;
};

export type MastercodeTransferHistory = {
  __typename?: 'MastercodeTransferHistory';
  dateTransferred: Scalars['DateTime'];
  id: Scalars['Int'];
  mastercode?: Maybe<Mastercode>;
  mastercodeId: Scalars['Int'];
  newOwnerEmail: Scalars['String'];
  previousOwnerEmail: Scalars['String'];
};

export enum MastercodeTransferHistoryOrderField {
  DATE_TRANSERRED = 'DATE_TRANSERRED',
  ID = 'ID',
  MASTERCODE_ID = 'MASTERCODE_ID',
  NEW_OWNER_EMAIL = 'NEW_OWNER_EMAIL',
  PREVIOUS_OWNER_EMAIL = 'PREVIOUS_OWNER_EMAIL',
}

export type MastercodeTransferHistoryOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<MastercodeTransferHistoryOrderField>;
};

export type MastercodeTransferHistoryWhereInput = {
  id: Scalars['Int'];
};

export type MastercodeTransferInput = {
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  ownerEmail: Scalars['String'];
};

export type MastercodeUpdateInput = {
  dateExpiration?: InputMaybe<Scalars['DateTime']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type MastercodeWhereInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  ownerEmail?: InputMaybe<Scalars['String']>;
};

export type MastercodesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<MastercodeOrderField>;
};

export type MastercodesWhereInput = {
  code?: InputMaybe<Array<Scalars['String']>>;
  expired?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  includeRemoved?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Array<Scalars['Int']>>;
  orderItems?: InputMaybe<MastercodeOrderItemsWhereInput>;
  orders?: InputMaybe<MastercodeOrdersWhereInput>;
  organizations?: InputMaybe<MastercodeOrganizationsWhereInput>;
  ownerEmail?: InputMaybe<Array<Scalars['String']>>;
  ownerEmail_contains?: InputMaybe<Scalars['String']>;
  parentMastercodeId?: InputMaybe<Array<Scalars['Int']>>;
  products?: InputMaybe<ProductsWhereInput>;
  status?: InputMaybe<Array<MastercodeStatus>>;
  unlocked?: InputMaybe<Scalars['Boolean']>;
};

export type Media = {
  __typename?: 'Media';
  mediaType: MediaType;
  src: Scalars['String'];
};

export enum MediaType {
  AUDIO = 'AUDIO',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
}

export enum MimeType {
  AUDIO_MP4 = 'AUDIO_MP4',
  JPEG = 'JPEG',
  JPG = 'JPG',
  MP3 = 'MP3',
  MP4 = 'MP4',
  MPEG = 'MPEG',
  PDF = 'PDF',
  PNG = 'PNG',
}

export type Mutation = {
  __typename?: 'Mutation';
  _dummyCore?: Maybe<Scalars['Boolean']>;
  _dummyFulfillment?: Maybe<Scalars['Boolean']>;
  _dummyLicenseManager?: Maybe<Scalars['Boolean']>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  archiveClassroom?: Maybe<Classroom>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  archiveClassrooms?: Maybe<BatchMutationResult>;
  assignAvailableLicense?: Maybe<License>;
  assignLicense?: Maybe<License>;
  bulkAssignAvailableLicenses: Array<BulkAssignResult>;
  bulkGroupEnrollmentAction?: Maybe<Array<BulkGroupEnrollmentActionResult>>;
  bulkLicenseAction: Array<BulkLicenseActionResult>;
  /**
   * - Required privileges:
   *   - academic-session.create
   */
  createAcademicSession?: Maybe<AcademicSession>;
  createAccessActivityPageEvent?: Maybe<Scalars['Void']>;
  createAccessLinkEvent?: Maybe<Scalars['Void']>;
  createAccessPageEvent?: Maybe<Scalars['Void']>;
  createAccessResourceEvent?: Maybe<Scalars['Void']>;
  createAssignment?: Maybe<Assignment>;
  createAssignments: Array<Maybe<Assignment>>;
  /**
   * - Required privileges:
   *   - classroom.create
   */
  createClassroom?: Maybe<Classroom>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   * @deprecated No longer supported
   */
  createClassroomSetting?: Maybe<ClassroomSetting>;
  /**
   * - Required privileges:
   *   - contact.create
   */
  createContact?: Maybe<Contact>;
  createCustomTeachingOrder?: Maybe<CustomTeachingOrder>;
  createFavorite?: Maybe<Favorite>;
  createFeatureToggle?: Maybe<FeatureToggle>;
  createGroup?: Maybe<Group>;
  createLoginSuccessEvent?: Maybe<Scalars['Void']>;
  /**
   * - Required privileges:
   *   - organization.create
   */
  createOrganization?: Maybe<Organization>;
  createReadBookEvent?: Maybe<Scalars['Void']>;
  /**
   * - Required privileges:
   *   - student.create
   */
  createStudent?: Maybe<Student>;
  /**
   * - Required privileges:
   *   - student-setting.write
   * @deprecated No longer supported
   */
  createStudentSetting?: Maybe<StudentSetting>;
  /**
   * - Required privileges:
   *   - student.create
   */
  createStudents: Array<Maybe<Student>>;
  createTeachingOrderChangedEvent?: Maybe<Scalars['Void']>;
  /**
   * - Required privileges:
   *   - user.create
   */
  createUser?: Maybe<User>;
  /**
   * - Required privileges:
   *   - user-setting.write
   * @deprecated No longer supported
   */
  createUserSetting?: Maybe<UserSetting>;
  createViewTabEvent?: Maybe<Scalars['Void']>;
  deleteAssignment?: Maybe<Scalars['Int']>;
  deleteCustomTeachingOrder?: Maybe<CustomTeachingOrder>;
  deleteFavorite?: Maybe<Favorite>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  enroll?: Maybe<Array<Maybe<Enrollment>>>;
  enrollGroup?: Maybe<Array<GroupEnrollment>>;
  expireMastercode: Mastercode;
  extendMastercode: Mastercode;
  logApiError?: Maybe<Scalars['Void']>;
  logApplicationError?: Maybe<Scalars['Void']>;
  moveMastercode: Mastercode;
  /**
   * - Required privileges:
   *   - academic-session.write
   */
  removeAcademicSession?: Maybe<AcademicSession>;
  /**
   * - Required privileges:
   *   - academic-session.write
   */
  removeAcademicSessions?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  removeClassroom?: Maybe<Classroom>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   */
  removeClassroomSetting?: Maybe<Scalars['Void']>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   */
  removeClassroomSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  removeClassrooms?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - contact.write
   */
  removeContact?: Maybe<Contact>;
  /**
   * - Required privileges:
   *   - contact.write
   */
  removeContacts: BatchMutationResult;
  removeFeatureToggle?: Maybe<FeatureToggle>;
  removeFeatureToggles?: Maybe<BatchMutationResult>;
  removeGroup?: Maybe<Group>;
  removeGroups: BatchMutationResult;
  /**
   * - Required privileges:
   *   - organization.write
   */
  removeOrganization?: Maybe<Organization>;
  removeOrganizationSetting?: Maybe<Scalars['Void']>;
  removeOrganizationSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - organization.write
   */
  removeOrganizations?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - student.write
   */
  removeStudent?: Maybe<Student>;
  /**
   * - Required privileges:
   *   - contact.write
   */
  removeStudentFromContact: BatchMutationResult;
  /**
   * - Required privileges:
   *   - student-setting.write
   */
  removeStudentSetting?: Maybe<Scalars['Void']>;
  /**
   * - Required privileges:
   *   - student-setting.write
   */
  removeStudentSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - student.write
   */
  removeStudents?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - user.write
   */
  removeUser?: Maybe<User>;
  /**
   * - Required privileges:
   *   - user-setting.write
   */
  removeUserSetting?: Maybe<Scalars['Void']>;
  /**
   * - Required privileges:
   *   - user-setting.write
   */
  removeUserSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - user.write
   */
  removeUsers?: Maybe<BatchMutationResult>;
  saveAttempt?: Maybe<Attempt>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   */
  saveClassroomSetting?: Maybe<ClassroomSetting>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   */
  saveClassroomSettings?: Maybe<BatchMutationResult>;
  saveOrganizationSetting?: Maybe<OrganizationSetting>;
  saveOrganizationSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - student-setting.write
   */
  saveStudentSetting?: Maybe<StudentSetting>;
  /**
   * - Required privileges:
   *   - student-setting.write
   */
  saveStudentSettings?: Maybe<BatchMutationResult>;
  saveToursSettings: Array<Maybe<TourSettings>>;
  /**
   * - Required privileges:
   *   - user-setting.write
   */
  saveUserSetting?: Maybe<UserSetting>;
  /**
   * - Required privileges:
   *   - user-setting.write
   */
  saveUserSettings?: Maybe<BatchMutationResult>;
  scheduleUnlockMastercode: Mastercode;
  scheduleUnlockOrderMastercodes: BatchMutationResult;
  skipAssignment: Array<Maybe<Attempt>>;
  swapLicenses: Array<Maybe<License>>;
  transferMastercode: Mastercode;
  transferOrderMastercodes: BatchMutationResult;
  /**
   * - Required privileges:
   *   - student.write
   */
  transferStudent?: Maybe<Enrollment>;
  unassignLicense?: Maybe<License>;
  unassignLicenses?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  unenroll?: Maybe<BatchMutationResult>;
  unenrollGroup?: Maybe<BatchMutationResult>;
  unlockMastercode: ProvisioningResult;
  unlockOrderMastercodes: ProvisioningResult;
  unskipAssignment: Array<Maybe<Attempt>>;
  /**
   * - Required privileges:
   *   - academic-session.write
   */
  updateAcademicSession?: Maybe<AcademicSession>;
  /**
   * - Required privileges:
   *   - academic-session.write
   */
  updateAcademicSessions?: Maybe<BatchMutationResult>;
  updateAssignment?: Maybe<Assignment>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  updateClassroom?: Maybe<Classroom>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   * @deprecated No longer supported
   */
  updateClassroomSetting?: Maybe<ClassroomSetting>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   * @deprecated No longer supported
   */
  updateClassroomSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  updateClassrooms?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - contact.write
   */
  updateContact?: Maybe<Contact>;
  /**
   * - Required privileges:
   *   - contact.write
   */
  updateContacts: BatchMutationResult;
  updateCustomTeachingOrder?: Maybe<CustomTeachingOrder>;
  updateFavorite?: Maybe<Favorite>;
  updateFeatureToggle?: Maybe<FeatureToggle>;
  updateFeatureToggles?: Maybe<BatchMutationResult>;
  updateGroup?: Maybe<Group>;
  updateLicense?: Maybe<License>;
  updateLicenses?: Maybe<BatchMutationResult>;
  updateMe?: Maybe<User>;
  /**
   * - Required privileges:
   *   - organization.write
   */
  updateOrganization?: Maybe<Organization>;
  /**
   * - Required privileges:
   *   - organization.write
   */
  updateOrganizations?: Maybe<BatchMutationResult>;
  updateSiteLicense?: Maybe<SiteLicense>;
  updateSiteLicenses?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - student.write
   */
  updateStudent?: Maybe<Student>;
  /**
   * - Required privileges:
   *   - student-setting.write
   * @deprecated No longer supported
   */
  updateStudentSetting?: Maybe<StudentSetting>;
  /**
   * - Required privileges:
   *   - student-setting.write
   * @deprecated No longer supported
   */
  updateStudentSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - student.write
   */
  updateStudents?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - user.write
   */
  updateUser?: Maybe<User>;
  /**
   * - Required privileges:
   *   - user-setting.write
   * @deprecated No longer supported
   */
  updateUserSetting?: Maybe<UserSetting>;
  /**
   * - Required privileges:
   *   - user-setting.write
   * @deprecated No longer supported
   */
  updateUserSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - user.write
   */
  updateUsers?: Maybe<BatchMutationResult>;
};

export type MutationArchiveClassroomArgs = {
  where: ClassroomWhereInput;
};

export type MutationArchiveClassroomsArgs = {
  where: ClassroomsWhereInput;
};

export type MutationAssignAvailableLicenseArgs = {
  data: AssignAvailableLicenseInput;
  where: AssignAvailableLicenseWhereInput;
};

export type MutationAssignLicenseArgs = {
  data: LicenseAssignInput;
  where: LicenseWhereInput;
};

export type MutationBulkAssignAvailableLicensesArgs = {
  data: Array<BulkAssignAvailableLicenseInput>;
  where?: InputMaybe<BulkAssignAvailableWhereInput>;
};

export type MutationBulkGroupEnrollmentActionArgs = {
  data: Array<BulkGroupEnrollmentActionInput>;
};

export type MutationBulkLicenseActionArgs = {
  data: Array<BulkLicenseActionInput>;
  where?: InputMaybe<BulkLicenseActionWhereInput>;
};

export type MutationCreateAcademicSessionArgs = {
  data: AcademicSessionCreateInput;
};

export type MutationCreateAccessActivityPageEventArgs = {
  data: AccessActivityPageEventCreateInput;
};

export type MutationCreateAccessLinkEventArgs = {
  data: AccessLinkEventCreateInput;
};

export type MutationCreateAccessPageEventArgs = {
  data: AccessPageEventCreateInput;
};

export type MutationCreateAccessResourceEventArgs = {
  data: AccessResourceEventCreateInput;
};

export type MutationCreateAssignmentArgs = {
  data: AssignmentCreateInput;
};

export type MutationCreateAssignmentsArgs = {
  data: AssignmentsCreateInput;
};

export type MutationCreateClassroomArgs = {
  data: ClassroomCreateInput;
};

export type MutationCreateClassroomSettingArgs = {
  data: ClassroomSettingCreateInput;
};

export type MutationCreateContactArgs = {
  data: ContactInput;
};

export type MutationCreateCustomTeachingOrderArgs = {
  data: CustomTeachingOrderCreateInput;
};

export type MutationCreateFavoriteArgs = {
  data: FavoriteCreateInput;
};

export type MutationCreateFeatureToggleArgs = {
  data: FeatureToggleInput;
};

export type MutationCreateGroupArgs = {
  data: GroupCreateInput;
};

export type MutationCreateLoginSuccessEventArgs = {
  data: LoginSuccessEventCreateInput;
};

export type MutationCreateOrganizationArgs = {
  data: OrganizationCreateInput;
};

export type MutationCreateReadBookEventArgs = {
  data: ReadBookEventCreateInput;
};

export type MutationCreateStudentArgs = {
  data: StudentCreateInput;
};

export type MutationCreateStudentSettingArgs = {
  data: StudentSettingCreateInput;
};

export type MutationCreateStudentsArgs = {
  data: Array<StudentCreateInput>;
};

export type MutationCreateTeachingOrderChangedEventArgs = {
  data: TeachingOrderChangedEventCreateInput;
};

export type MutationCreateUserArgs = {
  data: UserCreateInput;
  upsert?: InputMaybe<Scalars['Boolean']>;
};

export type MutationCreateUserSettingArgs = {
  data: UserSettingCreateInput;
};

export type MutationCreateViewTabEventArgs = {
  data: ViewTabEventCreateInput;
};

export type MutationDeleteAssignmentArgs = {
  data: AssignmentDeleteInput;
};

export type MutationDeleteCustomTeachingOrderArgs = {
  data: CustomTeachingOrderDeleteInput;
};

export type MutationDeleteFavoriteArgs = {
  data: FavoriteDeleteInput;
};

export type MutationEnrollArgs = {
  classroomId: Scalars['Int'];
  studentIds?: InputMaybe<Array<Scalars['Int']>>;
  userEnrollments?: InputMaybe<Array<UserEnrollmentInput>>;
};

export type MutationEnrollGroupArgs = {
  groupId: Scalars['Int'];
  studentIds: Array<Scalars['Int']>;
};

export type MutationExpireMastercodeArgs = {
  data?: InputMaybe<MastercodeUpdateInput>;
  where: MastercodeWhereInput;
};

export type MutationExtendMastercodeArgs = {
  data: MastercodeUpdateInput;
  where: MastercodeWhereInput;
};

export type MutationLogApiErrorArgs = {
  data: LogApiErrorInput;
};

export type MutationLogApplicationErrorArgs = {
  data: LogApplicationErrorInput;
};

export type MutationMoveMastercodeArgs = {
  data: MastercodeUpdateInput;
  where: MastercodeWhereInput;
};

export type MutationRemoveAcademicSessionArgs = {
  where: AcademicSessionWhereInput;
};

export type MutationRemoveAcademicSessionsArgs = {
  where: AcademicSessionsWhereInput;
};

export type MutationRemoveClassroomArgs = {
  where: ClassroomWhereInput;
};

export type MutationRemoveClassroomSettingArgs = {
  where: ClassroomSettingWhereInput;
};

export type MutationRemoveClassroomSettingsArgs = {
  where: ClassroomSettingsWhereInput;
};

export type MutationRemoveClassroomsArgs = {
  where: ClassroomsWhereInput;
};

export type MutationRemoveContactArgs = {
  where: ContactWhereInput;
};

export type MutationRemoveContactsArgs = {
  where: ContactsWhereInput;
};

export type MutationRemoveFeatureToggleArgs = {
  where: FeatureToggleWhereInput;
};

export type MutationRemoveFeatureTogglesArgs = {
  where: FeatureTogglesWhereInput;
};

export type MutationRemoveGroupArgs = {
  where: GroupWhereInput;
};

export type MutationRemoveGroupsArgs = {
  where: GroupsWhereInput;
};

export type MutationRemoveOrganizationArgs = {
  where: OrganizationWhereInput;
};

export type MutationRemoveOrganizationSettingArgs = {
  where: OrganizationSettingWhereInput;
};

export type MutationRemoveOrganizationSettingsArgs = {
  where: OrganizationSettingsWhereInput;
};

export type MutationRemoveOrganizationsArgs = {
  where: OrganizationsWhereInput;
};

export type MutationRemoveStudentArgs = {
  where: StudentWhereInput;
};

export type MutationRemoveStudentFromContactArgs = {
  data: ContactStudentRemoveInput;
};

export type MutationRemoveStudentSettingArgs = {
  where: StudentSettingWhereInput;
};

export type MutationRemoveStudentSettingsArgs = {
  where: StudentSettingsWhereInput;
};

export type MutationRemoveStudentsArgs = {
  where: StudentsWhereInput;
};

export type MutationRemoveUserArgs = {
  where: UserWhereInput;
};

export type MutationRemoveUserSettingArgs = {
  where: UserSettingWhereInput;
};

export type MutationRemoveUserSettingsArgs = {
  where: UserSettingsWhereInput;
};

export type MutationRemoveUsersArgs = {
  where: UsersWhereInput;
};

export type MutationSaveAttemptArgs = {
  data: SaveAttemptInput;
  fileUpload?: InputMaybe<FileUploadInput>;
};

export type MutationSaveClassroomSettingArgs = {
  value: Scalars['JSON'];
  where: ClassroomSettingWhereInput;
};

export type MutationSaveClassroomSettingsArgs = {
  value: Scalars['JSON'];
  where: ClassroomSettingsWhereInput;
};

export type MutationSaveOrganizationSettingArgs = {
  value: Scalars['JSON'];
  where: OrganizationSettingWhereInput;
};

export type MutationSaveOrganizationSettingsArgs = {
  value: Scalars['JSON'];
  where: OrganizationSettingsWhereInput;
};

export type MutationSaveStudentSettingArgs = {
  value: Scalars['JSON'];
  where: StudentSettingWhereInput;
};

export type MutationSaveStudentSettingsArgs = {
  value: Scalars['JSON'];
  where: StudentSettingsWhereInput;
};

export type MutationSaveToursSettingsArgs = {
  data: SaveToursSettingsInput;
};

export type MutationSaveUserSettingArgs = {
  value: Scalars['JSON'];
  where: UserSettingWhereInput;
};

export type MutationSaveUserSettingsArgs = {
  value: Scalars['JSON'];
  where: UserSettingsWhereInput;
};

export type MutationScheduleUnlockMastercodeArgs = {
  date: Scalars['DateTime'];
  where: MastercodeWhereInput;
};

export type MutationScheduleUnlockOrderMastercodesArgs = {
  date: Scalars['DateTime'];
  where: OrderWhereInput;
};

export type MutationSkipAssignmentArgs = {
  data: AssignmentSkipInput;
};

export type MutationSwapLicensesArgs = {
  data: SwapLicensesInput;
  where: SwapLicensesWhereInput;
};

export type MutationTransferMastercodeArgs = {
  data: MastercodeTransferInput;
  where: MastercodeWhereInput;
};

export type MutationTransferOrderMastercodesArgs = {
  data: MastercodeTransferInput;
  where: OrderWhereInput;
};

export type MutationTransferStudentArgs = {
  data: TransferStudentInput;
  where: TransferStudentWhereInput;
};

export type MutationUnassignLicenseArgs = {
  where: LicenseWhereInput;
};

export type MutationUnassignLicensesArgs = {
  where: LicensesWhereInput;
};

export type MutationUnenrollArgs = {
  classroomId: Scalars['Int'];
  studentIds?: InputMaybe<Array<Scalars['Int']>>;
  userEnrollments?: InputMaybe<Array<UserEnrollmentInput>>;
};

export type MutationUnenrollGroupArgs = {
  groupId: Scalars['Int'];
  studentIds: Array<Scalars['Int']>;
};

export type MutationUnlockMastercodeArgs = {
  where: MastercodeWhereInput;
};

export type MutationUnlockOrderMastercodesArgs = {
  where: OrderWhereInput;
};

export type MutationUnskipAssignmentArgs = {
  data: AssignmentUnskipInput;
};

export type MutationUpdateAcademicSessionArgs = {
  data: AcademicSessionUpdateInput;
  where: AcademicSessionWhereInput;
};

export type MutationUpdateAcademicSessionsArgs = {
  data: AcademicSessionsUpdateInput;
  where: AcademicSessionsWhereInput;
};

export type MutationUpdateAssignmentArgs = {
  data: AssignmentUpdateInput;
};

export type MutationUpdateClassroomArgs = {
  data: ClassroomUpdateInput;
  where: ClassroomWhereInput;
};

export type MutationUpdateClassroomSettingArgs = {
  data: ClassroomSettingUpdateInput;
  where: ClassroomSettingWhereInput;
};

export type MutationUpdateClassroomSettingsArgs = {
  data: ClassroomSettingsUpdateInput;
  where: ClassroomSettingsWhereInput;
};

export type MutationUpdateClassroomsArgs = {
  data: ClassroomsUpdateInput;
  where: ClassroomsWhereInput;
};

export type MutationUpdateContactArgs = {
  data: ContactUpdateInput;
  where: ContactWhereInput;
};

export type MutationUpdateContactsArgs = {
  data: ContactUpdateInput;
  where: ContactsWhereInput;
};

export type MutationUpdateCustomTeachingOrderArgs = {
  data: CustomTeachingOrderUpdateInput;
};

export type MutationUpdateFavoriteArgs = {
  data: FavoriteUpdateInput;
};

export type MutationUpdateFeatureToggleArgs = {
  data: FeatureToggleUpdateInput;
  where: FeatureToggleWhereInput;
};

export type MutationUpdateFeatureTogglesArgs = {
  data: FeatureToggleUpdateInput;
  where: FeatureTogglesWhereInput;
};

export type MutationUpdateGroupArgs = {
  data: GroupUpdateInput;
};

export type MutationUpdateLicenseArgs = {
  data: LicenseUpdateInput;
  where: LicenseWhereInput;
};

export type MutationUpdateLicensesArgs = {
  data: LicenseUpdateInput;
  where: LicensesWhereInput;
};

export type MutationUpdateMeArgs = {
  data: UserUpdateInput;
};

export type MutationUpdateOrganizationArgs = {
  data: OrganizationUpdateInput;
  where: OrganizationWhereInput;
};

export type MutationUpdateOrganizationsArgs = {
  data: OrganizationsUpdateInput;
  where: OrganizationsWhereInput;
};

export type MutationUpdateSiteLicenseArgs = {
  data: SiteLicenseUpdateInput;
  where: SiteLicenseWhereInput;
};

export type MutationUpdateSiteLicensesArgs = {
  data: SiteLicenseUpdateInput;
  where: SiteLicensesWhereInput;
};

export type MutationUpdateStudentArgs = {
  data: StudentUpdateInput;
  where: StudentWhereInput;
};

export type MutationUpdateStudentSettingArgs = {
  data: StudentSettingUpdateInput;
  where: StudentSettingWhereInput;
};

export type MutationUpdateStudentSettingsArgs = {
  data: StudentSettingsUpdateInput;
  where: StudentSettingsWhereInput;
};

export type MutationUpdateStudentsArgs = {
  data: StudentsUpdateInput;
  where: StudentsWhereInput;
};

export type MutationUpdateUserArgs = {
  data: UserUpdateInput;
  where: UserWhereInput;
};

export type MutationUpdateUserSettingArgs = {
  data: UserSettingUpdateInput;
  where: UserSettingWhereInput;
};

export type MutationUpdateUserSettingsArgs = {
  data: UserSettingsUpdateInput;
  where: UserSettingsWhereInput;
};

export type MutationUpdateUsersArgs = {
  data: UsersUpdateInput;
  where: UsersWhereInput;
};

export type Offset = {
  __typename?: 'Offset';
  bottom?: Maybe<Scalars['Int']>;
  left?: Maybe<Scalars['Int']>;
  right?: Maybe<Scalars['Int']>;
  top?: Maybe<Scalars['Int']>;
};

export type Order = {
  __typename?: 'Order';
  cmsCustomerNumber?: Maybe<Scalars['String']>;
  crmNumber?: Maybe<Scalars['String']>;
  dateCreated: Scalars['DateTime'];
  dateFulfilled?: Maybe<Scalars['DateTime']>;
  dateOrdered: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  ecmsOrderNumber?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  itemFulfillmentNumber?: Maybe<Scalars['String']>;
  mastercodes?: Maybe<Array<Mastercode>>;
  orderItems?: Maybe<Array<OrderItem>>;
  orderNumber?: Maybe<Scalars['String']>;
  parentOrder?: Maybe<Order>;
  parentOrderId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']>;
};

export type OrderMastercodesArgs = {
  where?: InputMaybe<MastercodesWhereInput>;
};

export enum OrderDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type OrderItem = {
  __typename?: 'OrderItem';
  dateCreated: Scalars['DateTime'];
  dateExpiration?: Maybe<Scalars['DateTime']>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  id: Scalars['Int'];
  licenseCount: Scalars['Int'];
  licenseType: LicenseType;
  licenseTypeId: Scalars['Int'];
  licenses?: Maybe<Array<License>>;
  lineId?: Maybe<Scalars['Int']>;
  lineNumber?: Maybe<Scalars['Int']>;
  mastercode?: Maybe<Mastercode>;
  mastercodeId: Scalars['Int'];
  multiyearTerm?: Maybe<Scalars['Int']>;
  order: Order;
  orderId: Scalars['Int'];
  product?: Maybe<Product>;
  productId: Scalars['Int'];
  siteLicense?: Maybe<SiteLicense>;
  siteLicenseRangeMax?: Maybe<Scalars['Int']>;
  siteLicenseRangeMin?: Maybe<Scalars['Int']>;
};

export type OrderItemDateExpirationArgs = {
  where?: InputMaybe<OrderItemDateExpirationInput>;
};

export type OrderItemDateExpirationInput = {
  dateUnlocked?: InputMaybe<Scalars['DateTime']>;
};

export type OrderItemProvisioningResult = {
  __typename?: 'OrderItemProvisioningResult';
  dateExpiration?: Maybe<Scalars['DateTime']>;
  licenseCount: Scalars['Int'];
  orderItem?: Maybe<OrderItem>;
  orderItemId: Scalars['Int'];
};

export enum OrderOrderField {
  DATE_CREATED = 'DATE_CREATED',
  DATE_FULFILLED = 'DATE_FULFILLED',
  DATE_ORDERED = 'DATE_ORDERED',
  DATE_REMOVED = 'DATE_REMOVED',
  ID = 'ID',
  ITEM_FULFILLMENT_NUMBER = 'ITEM_FULFILLMENT_NUMBER',
  ORDER_NUMBER = 'ORDER_NUMBER',
  TYPE = 'TYPE',
  WEBSTORE_ORDER_NUMBER = 'WEBSTORE_ORDER_NUMBER',
}

export type OrderWhereInput = {
  id: Scalars['Int'];
  ownerEmail?: InputMaybe<Scalars['String']>;
};

export type OrdersOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<OrderOrderField>;
};

export type OrdersWhereInput = {
  AND?: InputMaybe<Array<OrdersWhereInput>>;
  OR?: InputMaybe<Array<OrdersWhereInput>>;
  completed?: InputMaybe<Scalars['Boolean']>;
  ecmsOrderNumber?: InputMaybe<Array<Scalars['String']>>;
  excludeTrialType?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  includeRemoved?: InputMaybe<Scalars['Boolean']>;
  itemFulfillmentNumber?: InputMaybe<Array<Scalars['String']>>;
  mastercode?: InputMaybe<Array<Scalars['String']>>;
  mastercodeId?: InputMaybe<Array<Scalars['Int']>>;
  orderNumber?: InputMaybe<Array<Scalars['String']>>;
  ownerEmail?: InputMaybe<Array<Scalars['String']>>;
  ownerEmail_contains?: InputMaybe<Scalars['String']>;
  parentOrderNumber?: InputMaybe<Array<Scalars['String']>>;
  products?: InputMaybe<ProductsWhereInput>;
  type?: InputMaybe<Array<Scalars['String']>>;
  type_contains?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Array<Scalars['Int']>>;
};

export type Organization = {
  __typename?: 'Organization';
  academicSessions?: Maybe<Array<Maybe<AcademicSession>>>;
  address?: Maybe<Scalars['String']>;
  ancestorMastercodes?: Maybe<Array<Mastercode>>;
  ancestorOrganizations?: Maybe<Array<Maybe<Organization>>>;
  city?: Maybe<Scalars['String']>;
  classrooms?: Maybe<Array<Classroom>>;
  dateCreated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  externalId?: Maybe<ExternalId>;
  id: Scalars['Int'];
  licenseUsage?: Maybe<Array<OrganizationLicenseUsage>>;
  licenses?: Maybe<Array<License>>;
  mastercodes?: Maybe<Array<Mastercode>>;
  mdrNumber?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ncesId?: Maybe<Scalars['String']>;
  organizationTypeId?: Maybe<Scalars['Int']>;
  parentOrganization?: Maybe<Organization>;
  parentOrganizationId?: Maybe<Scalars['Int']>;
  rootOrganization?: Maybe<Organization>;
  settings?: Maybe<Array<OrganizationSetting>>;
  sisId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stats: OrganizationStats;
  subOrganizations?: Maybe<Array<Maybe<Organization>>>;
  type: OrganizationType;
  users?: Maybe<Array<UserOrganization>>;
  zip?: Maybe<Scalars['String']>;
};

export type OrganizationAcademicSessionsArgs = {
  orderBy?: InputMaybe<AcademicSessionsOrderInput>;
  where?: InputMaybe<AcademicSessionsWhereInput>;
};

export type OrganizationAncestorMastercodesArgs = {
  orderBy?: InputMaybe<MastercodesOrderInput>;
  where?: InputMaybe<MastercodesWhereInput>;
};

export type OrganizationAncestorOrganizationsArgs = {
  maxHeight?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrganizationsOrderInput>;
  where?: InputMaybe<OrganizationsWhereInput>;
};

export type OrganizationLicenseUsageArgs = {
  where?: InputMaybe<LicenseUsageWhereInput>;
};

export type OrganizationLicensesArgs = {
  orderBy?: InputMaybe<LicensesOrderInput>;
  where?: InputMaybe<LicensesWhereInput>;
};

export type OrganizationMastercodesArgs = {
  orderBy?: InputMaybe<MastercodesOrderInput>;
  where?: InputMaybe<MastercodesWhereInput>;
};

export type OrganizationSettingsArgs = {
  orderBy?: InputMaybe<OrganizationSettingsOrderInput>;
  where?: InputMaybe<OrganizationSettingsWhereInput>;
};

export type OrganizationSubOrganizationsArgs = {
  maxDepth?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrganizationsOrderInput>;
  where?: InputMaybe<OrganizationsWhereInput>;
};

export type OrganizationUsersArgs = {
  where?: InputMaybe<UserOrganizationWhereInput>;
};

export type OrganizationCreateInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<ExternalIdInput>;
  mdrNumber?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  ncesId?: InputMaybe<Scalars['String']>;
  parentOrganizationId?: InputMaybe<Scalars['Int']>;
  sisId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  type: OrganizationType;
  zip?: InputMaybe<Scalars['String']>;
};

export type OrganizationLicenseUsage = {
  __typename?: 'OrganizationLicenseUsage';
  assignedCount: Scalars['Int'];
  availableCount: Scalars['Int'];
  classroomAssignedCount: Scalars['Int'];
  expiringCount: Scalars['Int'];
  inUseCount: Scalars['Int'];
  organizationId: Scalars['Int'];
  overageStats?: Maybe<OrganizationLicenseUsageOverageStats>;
  product: Product;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productId: Scalars['Int'];
  siteLicensed: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type OrganizationLicenseUsageOverageStats = {
  __typename?: 'OrganizationLicenseUsageOverageStats';
  assignedCount: Scalars['Int'];
  availableCount: Scalars['Int'];
  expiringCount: Scalars['Int'];
  overageLimitCount: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export enum OrganizationOrderField {
  ID = 'ID',
  NAME = 'NAME',
  ORGANIZATION_TYPE_ID = 'ORGANIZATION_TYPE_ID',
  PARENT_ORGANIZATION_ID = 'PARENT_ORGANIZATION_ID',
  SOURCE_ID = 'SOURCE_ID',
  SOURCE_KIND_ID = 'SOURCE_KIND_ID',
}

export type OrganizationPrivilege = {
  __typename?: 'OrganizationPrivilege';
  displayName: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  public: Scalars['Boolean'];
};

export enum OrganizationPrivilegeOrderField {
  ID = 'ID',
  NAME = 'NAME',
}

export type OrganizationPrivilegeWhereInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type OrganizationPrivilegesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<OrganizationPrivilegeOrderField>;
};

export type OrganizationPrivilegesWhereInput = {
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
};

export type OrganizationRole = {
  __typename?: 'OrganizationRole';
  app?: Maybe<App>;
  appId?: Maybe<Scalars['Int']>;
  classification: OrganizationRoleClassification;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  displayName: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  privileges?: Maybe<Array<Maybe<OrganizationPrivilege>>>;
  public: Scalars['Boolean'];
};

export enum OrganizationRoleClassification {
  ADMIN = 'ADMIN',
  AUDITOR = 'AUDITOR',
  FACULTY = 'FACULTY',
}

export enum OrganizationRoleOrderField {
  APP = 'APP',
  ID = 'ID',
  NAME = 'NAME',
  ORGANIZATION = 'ORGANIZATION',
}

export type OrganizationRoleWhereInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type OrganizationRolesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<OrganizationRoleOrderField>;
};

export type OrganizationRolesWhereInput = {
  appId?: InputMaybe<Array<Scalars['Int']>>;
  classification?: InputMaybe<Array<OrganizationRoleClassification>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
};

export type OrganizationSetting = {
  __typename?: 'OrganizationSetting';
  app?: Maybe<App>;
  appId?: Maybe<Scalars['Int']>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  id: Scalars['Int'];
  organization: Organization;
  organizationId: Scalars['Int'];
  product?: Maybe<Product>;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  setting: Scalars['String'];
  value: Scalars['JSON'];
};

export enum OrganizationSettingOrderField {
  APP_ID = 'APP_ID',
  ORGANIZATION_ID = 'ORGANIZATION_ID',
  PRODUCT_CURRICULUM_ID = 'PRODUCT_CURRICULUM_ID',
  PRODUCT_ID = 'PRODUCT_ID',
  SETTING = 'SETTING',
}

export type OrganizationSettingWhereInput = {
  appId?: InputMaybe<Scalars['Int']>;
  appName?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['Int'];
  productCode?: InputMaybe<Scalars['String']>;
  productCurriculumCode?: InputMaybe<Scalars['String']>;
  productCurriculumId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  setting: Scalars['String'];
};

export type OrganizationSettingsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<OrganizationSettingOrderField>;
};

export type OrganizationSettingsWhereInput = {
  appId?: InputMaybe<Array<Scalars['Int']>>;
  appName?: InputMaybe<Array<Scalars['String']>>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
  productCode?: InputMaybe<Array<Scalars['String']>>;
  productCurriculumCode?: InputMaybe<Array<Scalars['String']>>;
  productCurriculumId?: InputMaybe<Array<Scalars['Int']>>;
  productId?: InputMaybe<Array<Scalars['Int']>>;
  setting?: InputMaybe<Array<Scalars['String']>>;
};

export type OrganizationStats = {
  __typename?: 'OrganizationStats';
  classroomCount: Scalars['Int'];
  classroomStudentCount: Scalars['Int'];
  classroomUserCount: Scalars['Int'];
  enrolledStudentCount: Scalars['Int'];
  studentCount: Scalars['Int'];
  userCount: Scalars['Int'];
};

export enum OrganizationType {
  DEPARTMENT = 'DEPARTMENT',
  DISTRICT = 'DISTRICT',
  LOCAL = 'LOCAL',
  NATIONAL = 'NATIONAL',
  SCHOOL = 'SCHOOL',
  STATE = 'STATE',
  USER_GROUP = 'USER_GROUP',
}

export type OrganizationUpdateInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  dateRemoved?: InputMaybe<Scalars['DateTime']>;
  externalId?: InputMaybe<ExternalIdUpdateInput>;
  mdrNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ncesId?: InputMaybe<Scalars['String']>;
  parentOrganizationId?: InputMaybe<Scalars['Int']>;
  sisId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OrganizationType>;
  zip?: InputMaybe<Scalars['String']>;
};

export type OrganizationWhereInput = {
  externalId?: InputMaybe<ExternalIdInput>;
  id?: InputMaybe<Scalars['Int']>;
};

export type OrganizationsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<OrganizationOrderField>;
};

export type OrganizationsUpdateInput = {
  dateRemoved?: InputMaybe<Scalars['DateTime']>;
  parentOrganizationId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<OrganizationType>;
};

export type OrganizationsWhereInput = {
  AND?: InputMaybe<Array<OrganizationsWhereInput>>;
  OR?: InputMaybe<Array<OrganizationsWhereInput>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  includeRemoved?: InputMaybe<Scalars['Boolean']>;
  isRootOrganization?: InputMaybe<Scalars['Boolean']>;
  mdrNumber?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
  name_contains?: InputMaybe<Scalars['String']>;
  nsecId?: InputMaybe<Array<Scalars['String']>>;
  parentOrganization?: InputMaybe<OrganizationsWhereInput>;
  sisId?: InputMaybe<Array<Scalars['String']>>;
  sourceId?: InputMaybe<Array<Scalars['String']>>;
  sourceKind?: InputMaybe<Array<SourceKind>>;
  type?: InputMaybe<Array<OrganizationType>>;
};

export enum Orientation {
  LANDSCAPE = 'LANDSCAPE',
  PORTRAIT = 'PORTRAIT',
}

export type Page = {
  __typename?: 'Page';
  book: Book;
  bookId: Scalars['Int'];
  characters?: Maybe<Array<Character>>;
  id: Scalars['Int'];
  pageNumber?: Maybe<Scalars['Int']>;
  src?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<PageTag>>;
};

export enum PageLayout {
  DOUBLE_PAGE = 'DOUBLE_PAGE',
  SINGLE_PAGE = 'SINGLE_PAGE',
}

export enum PageOrderField {
  BOOK_ID = 'BOOK_ID',
  ID = 'ID',
  PAGE_NUMBER = 'PAGE_NUMBER',
}

export type PageTag = {
  __typename?: 'PageTag';
  id: Scalars['Int'];
  tag: Scalars['String'];
  value: Scalars['String'];
};

export type PagesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<PageOrderField>;
};

export type PagesWhereInput = {
  bookId?: InputMaybe<Scalars['Int']>;
  character?: InputMaybe<CharactersWhereInput>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  pageNumber?: InputMaybe<Array<Scalars['Int']>>;
};

export type PagingInput = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export enum Placement {
  ABOVE = 'ABOVE',
  BELOW = 'BELOW',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export type Position = {
  __typename?: 'Position';
  offset?: Maybe<Offset>;
  placement?: Maybe<Placement>;
};

export type Product = {
  __typename?: 'Product';
  bannerUrl?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  color: Scalars['String'];
  curriculums?: Maybe<Array<ProductCurriculum>>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  defaultGradeLevel?: Maybe<Array<Scalars['String']>>;
  family: ProductFamily;
  gradeLevel?: Maybe<Array<Scalars['String']>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  trialAvailable: Scalars['Boolean'];
  type: ProductType;
};

export type ProductBundle = {
  __typename?: 'ProductBundle';
  code: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  products: Array<Maybe<Product>>;
};

export enum ProductBundleOrderField {
  CODE = 'CODE',
  DATE_CREATED = 'DATE_CREATED',
  DATE_UPDATED = 'DATE_UPDATED',
  ID = 'ID',
  NAME = 'NAME',
}

export type ProductBundleWhereInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type ProductBundlesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<ProductBundleOrderField>;
};

export type ProductBundlesWhereInput = {
  code?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
};

export type ProductCurriculum = {
  __typename?: 'ProductCurriculum';
  bannerUrl?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  color: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  defaultGradeLevel?: Maybe<Array<Scalars['String']>>;
  gradeLevel?: Maybe<Array<Scalars['String']>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  product?: Maybe<Product>;
  productId: Scalars['Int'];
  trialAvailable: Scalars['Boolean'];
};

export enum ProductCurriculumOrderField {
  CODE = 'CODE',
  ID = 'ID',
  NAME = 'NAME',
  PRODUCT_ID = 'PRODUCT_ID',
  TRIAL_AVAILABLE = 'TRIAL_AVAILABLE',
}

export type ProductCurriculumWhereInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type ProductCurriculumsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<ProductCurriculumOrderField>;
};

export type ProductCurriculumsWhereInput = {
  code?: InputMaybe<Array<Scalars['String']>>;
  gradeLevel?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  product?: InputMaybe<ProductsWhereInput>;
  trialAvailable?: InputMaybe<Array<Scalars['Boolean']>>;
  type?: InputMaybe<Array<ProductType>>;
};

export type ProductFamiliesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<ProductFamilyOrderField>;
};

export type ProductFamiliesWhereInput = {
  code?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
  pliManaged?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<ProductType>>;
};

export type ProductFamily = {
  __typename?: 'ProductFamily';
  bannerUrl?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  color: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  pliManaged?: Maybe<Scalars['Boolean']>;
  products: Array<Maybe<Product>>;
  types: Array<Maybe<ProductType>>;
};

export type ProductFamilyAccessDetails = {
  __typename?: 'ProductFamilyAccessDetails';
  bannerUrl: Scalars['String'];
  iosUrl?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export enum ProductFamilyOrderField {
  CODE = 'CODE',
  ID = 'ID',
  NAME = 'NAME',
}

export type ProductFamilyPurchaseDetails = {
  __typename?: 'ProductFamilyPurchaseDetails';
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type ProductFamilyWhereInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type ProductIdentifierInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

export enum ProductOrderField {
  CODE = 'CODE',
  ID = 'ID',
  NAME = 'NAME',
  PRODUCT_FAMILY_ID = 'PRODUCT_FAMILY_ID',
  TRIAL_AVAILABLE = 'TRIAL_AVAILABLE',
}

export enum ProductType {
  STUDENT = 'STUDENT',
  USER = 'USER',
}

export type ProductWhereInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type ProductsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<ProductOrderField>;
};

export type ProductsWhereInput = {
  code?: InputMaybe<Array<Scalars['String']>>;
  gradeLevel?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
  productFamilyId?: InputMaybe<Array<Scalars['Int']>>;
  trialAvailable?: InputMaybe<Array<Scalars['Boolean']>>;
  type?: InputMaybe<Array<ProductType>>;
};

export type ProvisioningResult = {
  __typename?: 'ProvisioningResult';
  fail?: Maybe<Array<OrderItemProvisioningResult>>;
  success?: Maybe<Array<OrderItemProvisioningResult>>;
};

export type Query = {
  __typename?: 'Query';
  _dummyCore?: Maybe<Scalars['Boolean']>;
  _dummyFulfillment?: Maybe<Scalars['Boolean']>;
  _dummyLicenseManager?: Maybe<Scalars['Boolean']>;
  /**
   * - Required privileges:
   *   - academic-session.read
   */
  academicSession?: Maybe<AcademicSession>;
  /**
   * - Required privileges:
   *   - academic-session.read
   */
  academicSessions: Array<Maybe<AcademicSession>>;
  apps: Array<Maybe<App>>;
  assignment?: Maybe<Assignment>;
  assignments: Array<Maybe<Assignment>>;
  availableLicenses: Array<Maybe<License>>;
  book?: Maybe<Book>;
  bookContent: Array<Maybe<BookContent>>;
  books: Array<Maybe<Book>>;
  /**
   * - Required privileges:
   *   - classroom.read
   */
  classroom?: Maybe<Classroom>;
  classroomPrivilege?: Maybe<ClassroomPrivilege>;
  classroomPrivileges?: Maybe<Array<Maybe<ClassroomPrivilege>>>;
  classroomRole?: Maybe<ClassroomRole>;
  classroomRoles?: Maybe<Array<Maybe<ClassroomRole>>>;
  /**
   * - Required privileges:
   *   - classroom-setting.read
   */
  classroomSetting?: Maybe<ClassroomSetting>;
  /**
   * - Required privileges:
   *   - classroom-setting.read
   */
  classroomSettings: Array<Maybe<ClassroomSetting>>;
  /**
   * - Required privileges:
   *   - classroom.read
   */
  classrooms?: Maybe<Array<Classroom>>;
  /**
   * - Required privileges:
   *   - contact.read
   */
  contact?: Maybe<Contact>;
  /**
   * - Required privileges:
   *   - contact.read
   */
  contacts: Array<Maybe<Contact>>;
  customTeachingOrder?: Maybe<CustomTeachingOrder>;
  customTeachingOrders?: Maybe<Array<Maybe<CustomTeachingOrder>>>;
  defaultGroupSettings?: Maybe<Array<DefaultGroupSetting>>;
  /**
   * - Required privileges:
   *   - classroom.read
   */
  enrollment?: Maybe<Enrollment>;
  /**
   * - Required privileges:
   *   - classroom.read
   */
  enrollments?: Maybe<Array<Maybe<Enrollment>>>;
  favorites: Array<Maybe<Favorite>>;
  featureToggle?: Maybe<FeatureToggle>;
  featureToggles: Array<Maybe<FeatureToggle>>;
  findTheLetter?: Maybe<FindTheLetterActivity>;
  findTheObjects?: Maybe<FindTheObjectsActivity>;
  group?: Maybe<Group>;
  groupCategories: Array<Maybe<GroupCategory>>;
  groupCategory?: Maybe<GroupCategory>;
  groupEnrollment?: Maybe<GroupEnrollment>;
  groupEnrollments: Array<Maybe<GroupEnrollment>>;
  groups: Array<Maybe<Group>>;
  license?: Maybe<License>;
  licenses: Array<Maybe<License>>;
  mastercode?: Maybe<Mastercode>;
  mastercodeTransferHistories?: Maybe<Array<MastercodeTransferHistory>>;
  mastercodeTransferHistory?: Maybe<MastercodeTransferHistory>;
  mastercodes?: Maybe<Array<Mastercode>>;
  me?: Maybe<User>;
  order?: Maybe<Order>;
  orders?: Maybe<Array<Order>>;
  /**
   * - Required privileges:
   *   - organization.read
   */
  organization?: Maybe<Organization>;
  organizationPrivilege?: Maybe<OrganizationPrivilege>;
  organizationPrivileges?: Maybe<Array<Maybe<OrganizationPrivilege>>>;
  organizationRole?: Maybe<OrganizationRole>;
  organizationRoles?: Maybe<Array<Maybe<OrganizationRole>>>;
  organizationSetting?: Maybe<OrganizationSetting>;
  organizationSettings: Array<Maybe<OrganizationSetting>>;
  /**
   * - Required privileges:
   *   - organization.read
   */
  organizations: Array<Maybe<Organization>>;
  pages: Array<Maybe<Page>>;
  product?: Maybe<Product>;
  productBundle?: Maybe<ProductBundle>;
  productBundles: Array<Maybe<ProductBundle>>;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculums: Array<ProductCurriculum>;
  productFamilies: Array<Maybe<ProductFamily>>;
  productFamily?: Maybe<ProductFamily>;
  products: Array<Maybe<Product>>;
  readAloud?: Maybe<ReadAloudActivity>;
  readStory?: Maybe<ReadStoryActivity>;
  readingLog?: Maybe<ReadingLog>;
  readingLogs: Array<Maybe<ReadingLog>>;
  resourceFilters: Array<Maybe<ResourceFilter>>;
  resourceTypes: Array<Maybe<ResourceType>>;
  resources: Array<Maybe<Resource>>;
  siteLicense?: Maybe<SiteLicense>;
  siteLicenses: Array<Maybe<SiteLicense>>;
  soundOutWords?: Maybe<SoundOutWordsActivity>;
  /**
   * - Required privileges:
   *   - student.read
   */
  student?: Maybe<Student>;
  studentProgress: Array<StudentProgress>;
  /**
   * - Required privileges:
   *   - student.read
   */
  studentSearch: Array<Student>;
  /**
   * - Required privileges:
   *   - student-setting.read
   */
  studentSetting?: Maybe<StudentSetting>;
  /**
   * - Required privileges:
   *   - student-setting.read
   */
  studentSettings: Array<Maybe<StudentSetting>>;
  /**
   * - Required privileges:
   *   - student.read
   */
  students: Array<Maybe<Student>>;
  teachingOrder?: Maybe<TeachingOrder>;
  teachingOrders?: Maybe<Array<Maybe<TeachingOrder>>>;
  tour?: Maybe<Tour>;
  tourStep?: Maybe<TourStep>;
  tourSteps: Array<Maybe<TourStep>>;
  tours: Array<Maybe<Tour>>;
  toursSettings: Array<Maybe<TourSettings>>;
  /**
   * - Required privileges:
   *   - user.read
   */
  user?: Maybe<User>;
  /**
   * - Required privileges:
   *   - user.read
   */
  userSearch: Array<User>;
  /**
   * - Required privileges:
   *   - user-setting.read
   */
  userSetting?: Maybe<UserSetting>;
  /**
   * - Required privileges:
   *   - user-setting.read
   */
  userSettings: Array<Maybe<UserSetting>>;
  /**
   * - Required privileges:
   *   - user.read
   */
  users: Array<User>;
};

export type QueryAcademicSessionArgs = {
  where: AcademicSessionWhereInput;
};

export type QueryAcademicSessionsArgs = {
  orderBy?: InputMaybe<AcademicSessionsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<AcademicSessionsWhereInput>;
};

export type QueryAssignmentArgs = {
  where: AssignmentWhereInput;
};

export type QueryAssignmentsArgs = {
  orderBy?: InputMaybe<AssignmentsOrderInput>;
  where: AssignmentsWhereInput;
};

export type QueryAvailableLicensesArgs = {
  where: FindAvailableLicenseWhereInput;
};

export type QueryBookArgs = {
  where: BookWhereInput;
};

export type QueryBookContentArgs = {
  where?: InputMaybe<BookWhereInput>;
};

export type QueryBooksArgs = {
  orderBy?: InputMaybe<BooksOrderInput>;
  where?: InputMaybe<BooksWhereInput>;
};

export type QueryClassroomArgs = {
  where: ClassroomWhereInput;
};

export type QueryClassroomPrivilegeArgs = {
  where: ClassroomPrivilegeWhereInput;
};

export type QueryClassroomPrivilegesArgs = {
  orderBy?: InputMaybe<ClassroomPrivilegesOrderInput>;
  where?: InputMaybe<ClassroomPrivilegesWhereInput>;
};

export type QueryClassroomRoleArgs = {
  where: ClassroomRoleWhereInput;
};

export type QueryClassroomRolesArgs = {
  orderBy?: InputMaybe<ClassroomRolesOrderInput>;
  where?: InputMaybe<ClassroomRolesWhereInput>;
};

export type QueryClassroomSettingArgs = {
  where: ClassroomSettingWhereInput;
};

export type QueryClassroomSettingsArgs = {
  orderBy?: InputMaybe<ClassroomSettingsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<ClassroomSettingsWhereInput>;
};

export type QueryClassroomsArgs = {
  orderBy?: InputMaybe<ClassroomsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<ClassroomsWhereInput>;
  whereUser?: InputMaybe<UsersWhereInput>;
};

export type QueryContactArgs = {
  where: ContactWhereInput;
};

export type QueryContactsArgs = {
  orderBy?: InputMaybe<ContactsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<ContactsWhereInput>;
};

export type QueryCustomTeachingOrderArgs = {
  where: CustomTeachingOrderWhereInput;
};

export type QueryEnrollmentArgs = {
  where: EnrollmentWhereInput;
};

export type QueryEnrollmentsArgs = {
  orderBy?: InputMaybe<EnrollmentsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<EnrollmentsWhereInput>;
};

export type QueryFavoritesArgs = {
  orderBy?: InputMaybe<FavoritesOrderInput>;
  where?: InputMaybe<FavoritesWhereInput>;
};

export type QueryFeatureToggleArgs = {
  where: FeatureToggleWhereInput;
};

export type QueryFeatureTogglesArgs = {
  orderBy?: InputMaybe<FeatureTogglesOrderInput>;
  where?: InputMaybe<FeatureTogglesWhereInput>;
};

export type QueryFindTheLetterArgs = {
  where: ReadActivityWhereInput;
};

export type QueryFindTheObjectsArgs = {
  where: ReadActivityWhereInput;
};

export type QueryGroupArgs = {
  where: GroupWhereInput;
};

export type QueryGroupCategoriesArgs = {
  orderBy?: InputMaybe<GroupCategoriesOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where: GroupCategoriesWhereInput;
};

export type QueryGroupCategoryArgs = {
  where: GroupCategoryWhereInput;
};

export type QueryGroupEnrollmentArgs = {
  where: GroupEnrollmentWhereInput;
};

export type QueryGroupEnrollmentsArgs = {
  orderBy?: InputMaybe<GroupEnrollmentsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where: GroupEnrollmentsWhereInput;
};

export type QueryGroupsArgs = {
  orderBy?: InputMaybe<GroupsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where: GroupsWhereInput;
};

export type QueryLicenseArgs = {
  where: LicenseWhereInput;
};

export type QueryLicensesArgs = {
  orderBy?: InputMaybe<LicensesOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<LicensesWhereInput>;
};

export type QueryMastercodeArgs = {
  where: MastercodeWhereInput;
};

export type QueryMastercodeTransferHistoriesArgs = {
  orderBy?: InputMaybe<MastercodeTransferHistoryOrderInput>;
  where: MastercodeTransferHistoriesWhereInput;
};

export type QueryMastercodeTransferHistoryArgs = {
  where: MastercodeTransferHistoryWhereInput;
};

export type QueryMastercodesArgs = {
  orderBy?: InputMaybe<MastercodesOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where: MastercodesWhereInput;
};

export type QueryOrderArgs = {
  where: OrderWhereInput;
};

export type QueryOrdersArgs = {
  mastercodeWhere?: InputMaybe<MastercodesWhereInput>;
  orderBy?: InputMaybe<OrdersOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<OrdersWhereInput>;
};

export type QueryOrganizationArgs = {
  where: OrganizationWhereInput;
};

export type QueryOrganizationPrivilegeArgs = {
  where: OrganizationPrivilegeWhereInput;
};

export type QueryOrganizationPrivilegesArgs = {
  orderBy?: InputMaybe<OrganizationPrivilegesOrderInput>;
  where?: InputMaybe<OrganizationPrivilegesWhereInput>;
};

export type QueryOrganizationRoleArgs = {
  where: OrganizationRoleWhereInput;
};

export type QueryOrganizationRolesArgs = {
  orderBy?: InputMaybe<OrganizationRolesOrderInput>;
  where?: InputMaybe<OrganizationRolesWhereInput>;
};

export type QueryOrganizationSettingArgs = {
  where: OrganizationSettingWhereInput;
};

export type QueryOrganizationSettingsArgs = {
  orderBy?: InputMaybe<OrganizationSettingsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<OrganizationSettingsWhereInput>;
};

export type QueryOrganizationsArgs = {
  orderBy?: InputMaybe<OrganizationsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<OrganizationsWhereInput>;
  whereUserOrganization?: InputMaybe<UserOrganizationInput>;
};

export type QueryPagesArgs = {
  orderBy?: InputMaybe<PagesOrderInput>;
  where: PagesWhereInput;
};

export type QueryProductArgs = {
  where: ProductWhereInput;
};

export type QueryProductBundleArgs = {
  where: ProductBundleWhereInput;
};

export type QueryProductBundlesArgs = {
  orderBy?: InputMaybe<ProductBundlesOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<ProductBundlesWhereInput>;
};

export type QueryProductCurriculumArgs = {
  where: ProductCurriculumWhereInput;
};

export type QueryProductCurriculumsArgs = {
  orderBy?: InputMaybe<ProductCurriculumsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<ProductCurriculumsWhereInput>;
};

export type QueryProductFamiliesArgs = {
  orderBy?: InputMaybe<ProductFamiliesOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<ProductFamiliesWhereInput>;
};

export type QueryProductFamilyArgs = {
  where: ProductFamilyWhereInput;
};

export type QueryProductsArgs = {
  orderBy?: InputMaybe<ProductsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<ProductsWhereInput>;
};

export type QueryReadAloudArgs = {
  where: ReadActivityWhereInput;
};

export type QueryReadStoryArgs = {
  where: ReadActivityWhereInput;
};

export type QueryReadingLogArgs = {
  where: ReadingLogWhereInput;
};

export type QueryReadingLogsArgs = {
  where: ReadingLogsWhereInput;
};

export type QueryResourceTypesArgs = {
  orderBy?: InputMaybe<ResourceTypesOrderInput>;
  where?: InputMaybe<ResourceTypesWhereInput>;
};

export type QueryResourcesArgs = {
  orderBy?: InputMaybe<ResourcesOrderInput>;
  where?: InputMaybe<ResourcesWhereInput>;
};

export type QuerySiteLicenseArgs = {
  where: SiteLicenseWhereInput;
};

export type QuerySiteLicensesArgs = {
  orderBy?: InputMaybe<SiteLicensesOrderInput>;
  where?: InputMaybe<SiteLicensesWhereInput>;
};

export type QuerySoundOutWordsArgs = {
  where: ReadActivityWhereInput;
};

export type QueryStudentArgs = {
  where: StudentWhereInput;
};

export type QueryStudentProgressArgs = {
  where: StudentProgressDataWhereInput;
};

export type QueryStudentSearchArgs = {
  classroomId?: InputMaybe<Array<Scalars['Int']>>;
  orderBy?: InputMaybe<StudentsOrderInput>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
  paging?: InputMaybe<PagingInput>;
  searchFields?: InputMaybe<Array<StudentSearchField>>;
  searchText: Scalars['String'];
  where?: InputMaybe<StudentsWhereInput>;
};

export type QueryStudentSettingArgs = {
  where: StudentSettingWhereInput;
};

export type QueryStudentSettingsArgs = {
  orderBy?: InputMaybe<StudentSettingsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<StudentSettingsWhereInput>;
};

export type QueryStudentsArgs = {
  orderBy?: InputMaybe<StudentsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<StudentsWhereInput>;
};

export type QueryTeachingOrderArgs = {
  where: TeachingOrderWhereInput;
};

export type QueryTourArgs = {
  where: TourWhereInput;
};

export type QueryTourStepArgs = {
  where: TourStepWhereInput;
};

export type QueryTourStepsArgs = {
  where: TourStepsWhereInput;
};

export type QueryToursArgs = {
  orderBy?: InputMaybe<ToursOrderInput>;
  where: ToursWhereInput;
};

export type QueryToursSettingsArgs = {
  where: ToursSettingsWhereInput;
};

export type QueryUserArgs = {
  where: UserWhereInput;
};

export type QueryUserSearchArgs = {
  classroomId?: InputMaybe<Array<Scalars['Int']>>;
  orderBy?: InputMaybe<UsersOrderInput>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
  paging?: InputMaybe<PagingInput>;
  searchFields?: InputMaybe<Array<UserSearchField>>;
  searchText: Scalars['String'];
  where?: InputMaybe<UsersWhereInput>;
};

export type QueryUserSettingArgs = {
  where: UserSettingWhereInput;
};

export type QueryUserSettingsArgs = {
  orderBy?: InputMaybe<UserSettingsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<UserSettingsWhereInput>;
};

export type QueryUsersArgs = {
  orderBy?: InputMaybe<UsersOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<UsersWhereInput>;
};

export type ReadActivityWhereInput = {
  book?: InputMaybe<BookWhereInput>;
  id?: InputMaybe<Scalars['Int']>;
  pages?: InputMaybe<PagesWhereInput>;
};

export type ReadAloudActivity = IActivity & {
  __typename?: 'ReadAloudActivity';
  activityType?: Maybe<ActivityType>;
  activityTypeId: Scalars['Int'];
  book?: Maybe<Book>;
  bookId: Scalars['Int'];
  description: Scalars['String'];
  id: Scalars['Int'];
  pages: Array<ReadAloudPage>;
  title: Scalars['String'];
};

export type ReadAloudPage = {
  __typename?: 'ReadAloudPage';
  contents?: Maybe<Array<Maybe<Asset>>>;
  page?: Maybe<Page>;
  pageId: Scalars['Int'];
};

export type ReadBookEventCreateInput = {
  activityType: Scalars['String'];
  bookCode: Scalars['String'];
  bookId: Scalars['Int'];
  bookType: BookType;
  character: CharacterInput;
  pageId: Scalars['Int'];
  pageLayout: PageLayout;
  pageNumber: Scalars['String'];
  section: ApplicationSection;
  timestamp: Scalars['DateTime'];
  word?: InputMaybe<WordInput>;
};

export type ReadStoryActivity = IActivity & {
  __typename?: 'ReadStoryActivity';
  activityType?: Maybe<ActivityType>;
  activityTypeId: Scalars['Int'];
  book?: Maybe<Book>;
  bookId: Scalars['Int'];
  description: Scalars['String'];
  id: Scalars['Int'];
  pages: Array<ReadStoryPage>;
  title: Scalars['String'];
};

export type ReadStoryPage = {
  __typename?: 'ReadStoryPage';
  page?: Maybe<Page>;
  pageId: Scalars['Int'];
  words?: Maybe<Array<Maybe<Asset>>>;
};

export type ReadingLog = {
  __typename?: 'ReadingLog';
  book: Book;
  bookId: Scalars['Int'];
  dateCompleted: Scalars['DateTime'];
  dateStarted: Scalars['DateTime'];
  id: Scalars['Int'];
  pagesRead: Scalars['Int'];
  studentId: Scalars['Int'];
};

export type ReadingLogWhereInput = {
  bookId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  studentId: Scalars['Int'];
};

export type ReadingLogsWhereInput = {
  bookId?: InputMaybe<Array<Scalars['Int']>>;
  studentId: Scalars['Int'];
};

export type Resource = {
  __typename?: 'Resource';
  asset?: Maybe<Asset>;
  assetId?: Maybe<Scalars['Int']>;
  characters: Array<Character>;
  data?: Maybe<Scalars['JSON']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  resourceProducts: Array<ResourceProduct>;
  resourceTypeId: Scalars['Int'];
  tags?: Maybe<Array<ResourceTag>>;
  thumbnail: Scalars['String'];
  title: Scalars['String'];
  type: ResourceType;
  url?: Maybe<Scalars['String']>;
};

export type ResourceFilter = {
  __typename?: 'ResourceFilter';
  name: Scalars['String'];
  values: Array<ResourceFilterValue>;
};

export type ResourceFilterValue = {
  __typename?: 'ResourceFilterValue';
  componentType: ComponentType;
  id: Scalars['Int'];
  value: Scalars['String'];
};

export enum ResourceOrderField {
  ID = 'ID',
  RESOURCE_TYPE_ID = 'RESOURCE_TYPE_ID',
  TITLE = 'TITLE',
}

export type ResourceProduct = {
  __typename?: 'ResourceProduct';
  id: Scalars['Int'];
  product: Product;
  productId: Scalars['Int'];
  resource: Resource;
  resourceId: Scalars['Int'];
};

export type ResourceTag = {
  __typename?: 'ResourceTag';
  componentType?: Maybe<ComponentType>;
  id: Scalars['Int'];
  tag: Scalars['String'];
  value: Scalars['String'];
};

export type ResourceType = {
  __typename?: 'ResourceType';
  icon?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  title: Scalars['String'];
  type: Scalars['String'];
};

export enum ResourceTypeOrderField {
  ID = 'ID',
  SORT_INDEX = 'SORT_INDEX',
  TITLE = 'TITLE',
}

export type ResourceTypesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<ResourceTypeOrderField>;
};

export type ResourceTypesWhereInput = {
  id?: InputMaybe<Array<Scalars['Int']>>;
  locale?: InputMaybe<Array<Locale>>;
  title?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Array<Scalars['String']>>;
};

export type ResourcesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<ResourceOrderField>;
};

export type ResourcesWhereInput = {
  character?: InputMaybe<CharactersWhereInput>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  resourceTypeId?: InputMaybe<Array<Scalars['Int']>>;
};

export enum RouteSource {
  DASHBOARD = 'DASHBOARD',
  MAIN_MENU = 'MAIN_MENU',
}

export type SaveAttemptInput = {
  assignmentActivityId: Scalars['Int'];
  dateCompleted?: InputMaybe<Scalars['DateTime']>;
  dateStarted?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<AttemptStatus>;
  studentId: Scalars['Int'];
};

export type SaveTourSettingsInput = {
  tourId: Scalars['Int'];
  tourStepSettings: Array<SaveTourStepSettingInput>;
};

export type SaveTourStepSettingInput = {
  tourStepId: Scalars['Int'];
  viewed: Scalars['Boolean'];
};

export type SaveToursSettingsInput = {
  studentId?: InputMaybe<Scalars['Int']>;
  toursSettings: Array<SaveTourSettingsInput>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type SiteLicense = {
  __typename?: 'SiteLicense';
  dateCreated: Scalars['DateTime'];
  dateExpiration: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  id: Scalars['Int'];
  licenseRangeMax: Scalars['Int'];
  licenseRangeMin: Scalars['Int'];
  licenseType: LicenseType;
  orderItemId: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  ownerUser?: Maybe<User>;
  ownerUserId: Scalars['Int'];
  productFamily?: Maybe<ProductFamily>;
  productFamilyId: Scalars['Int'];
};

export enum SiteLicenseOrderField {
  DATE_CREATED = 'DATE_CREATED',
  DATE_EXPIRATION = 'DATE_EXPIRATION',
  DATE_UPDATED = 'DATE_UPDATED',
  DATE_UPDATED_ASSIGNMENT = 'DATE_UPDATED_ASSIGNMENT',
  ID = 'ID',
  PRODUCT_ID = 'PRODUCT_ID',
}

export type SiteLicenseUpdateInput = {
  dateExpiration?: InputMaybe<Scalars['DateTime']>;
  orderItemId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

export type SiteLicenseWhereInput = {
  id: Scalars['Int'];
};

export type SiteLicensesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<SiteLicenseOrderField>;
};

export type SiteLicensesWhereInput = {
  expired?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  orderItemId?: InputMaybe<Array<Scalars['Int']>>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
  ownerUserId?: InputMaybe<Array<Scalars['Int']>>;
  productFamily?: InputMaybe<Array<ProductIdentifierInput>>;
};

export type SoundOutWordsActivity = IActivity & {
  __typename?: 'SoundOutWordsActivity';
  activityType?: Maybe<ActivityType>;
  activityTypeId: Scalars['Int'];
  book?: Maybe<Book>;
  bookId: Scalars['Int'];
  description: Scalars['String'];
  id: Scalars['Int'];
  pages: Array<SoundOutWordsPage>;
  title: Scalars['String'];
};

export type SoundOutWordsAsset = IAsset & {
  __typename?: 'SoundOutWordsAsset';
  capitalize?: Maybe<Scalars['Boolean']>;
  captions?: Maybe<Scalars['JSON']>;
  description: Scalars['String'];
  id: Scalars['Int'];
  narrationCaptions?: Maybe<Scalars['JSON']>;
  narrationSrc?: Maybe<Scalars['String']>;
  narrationVtt?: Maybe<Scalars['String']>;
  src: Scalars['String'];
  type: AssetType;
  vtt?: Maybe<Scalars['String']>;
};

export type SoundOutWordsPage = {
  __typename?: 'SoundOutWordsPage';
  contents?: Maybe<Asset>;
  page?: Maybe<Page>;
  pageId: Scalars['Int'];
  words?: Maybe<Array<Maybe<SoundOutWordsWord>>>;
};

export type SoundOutWordsWord = {
  __typename?: 'SoundOutWordsWord';
  sounds?: Maybe<Array<Maybe<Asset>>>;
  word: SoundOutWordsAsset;
};

export enum SourceKind {
  CLASS_LINK = 'CLASS_LINK',
  CLEVER = 'CLEVER',
  FIREBASE = 'FIREBASE',
  GOOGLE = 'GOOGLE',
  ONE_ROSTER = 'ONE_ROSTER',
  ONE_ROSTER_API = 'ONE_ROSTER_API',
  ONE_ROSTER_NYCPS = 'ONE_ROSTER_NYCPS',
}

export type Student = {
  __typename?: 'Student';
  classrooms?: Maybe<Array<Classroom>>;
  contacts?: Maybe<Array<Contact>>;
  dateCreated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<ExternalId>;
  firstName: Scalars['String'];
  gradeLevel: Scalars['String'];
  groups?: Maybe<Array<Group>>;
  id: Scalars['Int'];
  lastName: Scalars['String'];
  licenseUsage?: Maybe<Array<StudentLicenseUsage>>;
  licenses?: Maybe<Array<License>>;
  loginType: StudentLoginType;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  password?: Maybe<Scalars['String']>;
  settings?: Maybe<Array<StudentSetting>>;
  sisId?: Maybe<Scalars['String']>;
  status?: Maybe<StudentStatus>;
  toursSettings?: Maybe<Array<TourSettings>>;
  username: Scalars['String'];
};

export type StudentGroupsArgs = {
  orderBy?: InputMaybe<GroupsOrderInput>;
  where?: InputMaybe<GroupsWhereInput>;
};

export type StudentLicenseUsageArgs = {
  where?: InputMaybe<LicenseUsageWhereInput>;
};

export type StudentLicensesArgs = {
  orderBy?: InputMaybe<LicensesOrderInput>;
  where?: InputMaybe<LicensesWhereInput>;
};

export type StudentSettingsArgs = {
  orderBy?: InputMaybe<StudentSettingsOrderInput>;
  where?: InputMaybe<StudentSettingsWhereInput>;
};

export type StudentToursSettingsArgs = {
  where?: InputMaybe<ToursSettingsWhereInput>;
};

export type StudentContact = {
  __typename?: 'StudentContact';
  contactId: Scalars['Int'];
  studentId: Scalars['Int'];
};

export type StudentCreateInput = {
  classroomId?: InputMaybe<Array<Scalars['Int']>>;
  email?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<ExternalIdInput>;
  firstName: Scalars['String'];
  gradeLevel: Scalars['String'];
  group?: InputMaybe<Array<GroupUpsertInput>>;
  lastName: Scalars['String'];
  licenses?: InputMaybe<Array<CreateEntityLicenseAssignInput>>;
  loginType?: InputMaybe<StudentLoginType>;
  organizationId: Scalars['Int'];
  password?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Array<BaseSettingCreateInput>>;
  sisId?: InputMaybe<Scalars['String']>;
  username: Scalars['String'];
};

export type StudentLicenseUsage = {
  __typename?: 'StudentLicenseUsage';
  active: Scalars['Boolean'];
  assignedCount: Scalars['Int'];
  manualAssignment: Scalars['Boolean'];
  product: Product;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productId: Scalars['Int'];
  trial: Scalars['Boolean'];
};

export enum StudentLoginType {
  LETTER_CARDS = 'LETTER_CARDS',
  TEXTBOX = 'TEXTBOX',
}

export type StudentProgress = {
  __typename?: 'StudentProgress';
  characterProgress: Array<CharacterProgress>;
  student?: Maybe<Student>;
  studentId: Scalars['Int'];
};

export type StudentProgressDataWhereInput = {
  characterId?: InputMaybe<Array<Scalars['Int']>>;
  classroomId: Array<Scalars['Int']>;
  studentId: Array<Scalars['Int']>;
};

export enum StudentSearchField {
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
}

export type StudentSetting = {
  __typename?: 'StudentSetting';
  app: App;
  appId: Scalars['Int'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  id: Scalars['Int'];
  product?: Maybe<Product>;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  setting: Scalars['String'];
  student: Student;
  studentId: Scalars['Int'];
  value: Scalars['JSON'];
};

export type StudentSettingCreateInput = {
  appId?: InputMaybe<Scalars['Int']>;
  appName?: InputMaybe<Scalars['String']>;
  productCode?: InputMaybe<Scalars['String']>;
  productCurriculumCode?: InputMaybe<Scalars['String']>;
  productCurriculumId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  setting: Scalars['String'];
  studentId: Scalars['Int'];
  value: Scalars['JSON'];
};

export enum StudentSettingOrderField {
  APP_ID = 'APP_ID',
  PRODUCT_CURRICULUM_ID = 'PRODUCT_CURRICULUM_ID',
  PRODUCT_ID = 'PRODUCT_ID',
  SETTING = 'SETTING',
  STUDENT_ID = 'STUDENT_ID',
}

export type StudentSettingUpdateInput = {
  appId?: InputMaybe<Scalars['Int']>;
  setting?: InputMaybe<Scalars['String']>;
  studentId?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type StudentSettingWhereInput = {
  appId?: InputMaybe<Scalars['Int']>;
  appName?: InputMaybe<Scalars['String']>;
  productCode?: InputMaybe<Scalars['String']>;
  productCurriculumCode?: InputMaybe<Scalars['String']>;
  productCurriculumId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  setting: Scalars['String'];
  studentId: Scalars['Int'];
};

export type StudentSettingsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<StudentSettingOrderField>;
};

export type StudentSettingsUpdateInput = {
  appId?: InputMaybe<Scalars['Int']>;
  setting?: InputMaybe<Scalars['String']>;
  studentId?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type StudentSettingsWhereInput = {
  appId?: InputMaybe<Array<Scalars['Int']>>;
  appName?: InputMaybe<Array<Scalars['String']>>;
  productCode?: InputMaybe<Array<Scalars['String']>>;
  productCurriculumCode?: InputMaybe<Array<Scalars['String']>>;
  productCurriculumId?: InputMaybe<Array<Scalars['Int']>>;
  productId?: InputMaybe<Array<Scalars['Int']>>;
  setting?: InputMaybe<Array<Scalars['String']>>;
  studentId?: InputMaybe<Array<Scalars['Int']>>;
};

export enum StudentStatus {
  ACTIVE = 'ACTIVE',
  REMOVED = 'REMOVED',
}

export type StudentUpdateInput = {
  dateRemoved?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<ExternalIdInput>;
  firstName?: InputMaybe<Scalars['String']>;
  gradeLevel?: InputMaybe<Scalars['String']>;
  groups?: InputMaybe<Array<GroupUpsertInput>>;
  lastName?: InputMaybe<Scalars['String']>;
  loginType?: InputMaybe<StudentLoginType>;
  organizationId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  sisId?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type StudentWhereInput = {
  authToken?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<ExternalIdInput>;
  id?: InputMaybe<Scalars['Int']>;
};

export enum StudentsOrderField {
  FIRST_NAME = 'FIRST_NAME',
  GRADE_LEVEL = 'GRADE_LEVEL',
  ID = 'ID',
  LAST_NAME = 'LAST_NAME',
  PASSWORD = 'PASSWORD',
  SOURCE_ID = 'SOURCE_ID',
  SOURCE_KIND_ID = 'SOURCE_KIND_ID',
  USERNAME = 'USERNAME',
}

export type StudentsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<StudentsOrderField>;
};

export type StudentsUpdateInput = {
  dateRemoved?: InputMaybe<Scalars['DateTime']>;
  gradeLevel?: InputMaybe<Scalars['String']>;
  loginType?: InputMaybe<StudentLoginType>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

export type StudentsWhereInput = {
  AND?: InputMaybe<Array<StudentsWhereInput>>;
  OR?: InputMaybe<Array<StudentsWhereInput>>;
  authToken?: InputMaybe<Array<Scalars['String']>>;
  classrooms?: InputMaybe<ClassroomsWhereInput>;
  email?: InputMaybe<Array<Scalars['String']>>;
  email_contains?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Array<Scalars['String']>>;
  firstName_contains?: InputMaybe<Scalars['String']>;
  gradeLevel?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  includeRemoved?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Array<Scalars['String']>>;
  lastName_contains?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
  organizations?: InputMaybe<OrganizationsWhereInput>;
  sourceId?: InputMaybe<Array<Scalars['String']>>;
  sourceKind?: InputMaybe<Array<SourceKind>>;
  status?: InputMaybe<Array<StudentStatus>>;
  username?: InputMaybe<Array<Scalars['String']>>;
  username_contains?: InputMaybe<Scalars['String']>;
};

export type SwapLicensesInput = {
  toProductId: Scalars['Int'];
};

export type SwapLicensesWhereInput = {
  count?: InputMaybe<Scalars['Int']>;
  expiresAfter?: InputMaybe<Scalars['DateTime']>;
  fromProductId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

export type TeachingOrder = {
  __typename?: 'TeachingOrder';
  active: Scalars['Boolean'];
  characters: Array<Character>;
  default: Scalars['Boolean'];
  documentation?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type TeachingOrderChangedEventCreateInput = {
  custom: Scalars['Boolean'];
  teachingOrderId: Scalars['Int'];
  timestamp: Scalars['DateTime'];
};

export type TeachingOrderWhereInput = {
  id: Scalars['Int'];
};

export type Tour = {
  __typename?: 'Tour';
  app: App;
  appId: Scalars['Int'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  product?: Maybe<Product>;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  tourSteps: Array<TourStep>;
};

export enum TourOrderField {
  APP_ID = 'APP_ID',
  ID = 'ID',
  NAME = 'NAME',
  PRODUCT_CURRICULUM_ID = 'PRODUCT_CURRICULUM_ID',
  PRODUCT_ID = 'PRODUCT_ID',
}

export type TourSettings = {
  __typename?: 'TourSettings';
  tour?: Maybe<Tour>;
  tourId: Scalars['Int'];
  tourStepSettings: Array<TourStepSetting>;
};

export type TourStep = {
  __typename?: 'TourStep';
  assetId?: Maybe<Scalars['Int']>;
  data?: Maybe<Scalars['JSON']>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  groupName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  media?: Maybe<Media>;
  name: Scalars['String'];
  position?: Maybe<Position>;
  text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  tour: Tour;
  tourId: Scalars['Int'];
};

export type TourStepSetting = {
  __typename?: 'TourStepSetting';
  tourStep?: Maybe<TourStep>;
  tourStepId: Scalars['Int'];
  viewed: Scalars['Boolean'];
};

export type TourStepWhereInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  tourId?: InputMaybe<Scalars['Int']>;
};

export type TourStepsWhereInput = {
  id?: InputMaybe<Array<Scalars['Int']>>;
  tourId?: InputMaybe<Array<Scalars['Int']>>;
};

export type TourWhereInput = {
  appId?: InputMaybe<Scalars['Int']>;
  appName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  productCode?: InputMaybe<Scalars['String']>;
  productCurriculumCode?: InputMaybe<Scalars['String']>;
  productCurriculumId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
};

export type ToursOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<TourOrderField>;
};

export type ToursSettingsWhereInput = {
  productCode?: InputMaybe<Array<Scalars['String']>>;
  productCurriculumCode?: InputMaybe<Array<Scalars['String']>>;
  productCurriculumId?: InputMaybe<Array<Scalars['Int']>>;
  productId?: InputMaybe<Array<Scalars['Int']>>;
  studentId?: InputMaybe<Scalars['Int']>;
  tours?: InputMaybe<Array<Scalars['String']>>;
  toursSteps?: InputMaybe<Array<Scalars['String']>>;
  userId?: InputMaybe<Scalars['Int']>;
  viewed?: InputMaybe<Scalars['Boolean']>;
};

export type ToursWhereInput = {
  appId?: InputMaybe<Array<Scalars['Int']>>;
  appName?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
  productCode?: InputMaybe<Array<Scalars['String']>>;
  productCurriculumCode?: InputMaybe<Array<Scalars['String']>>;
  productCurriculumId?: InputMaybe<Array<Scalars['Int']>>;
  productId?: InputMaybe<Array<Scalars['Int']>>;
};

export type TransferStudentInput = {
  fromClassroomId: Scalars['Int'];
  toClassroomId: Scalars['Int'];
};

export type TransferStudentWhereInput = {
  studentId: Scalars['Int'];
};

export type User = {
  __typename?: 'User';
  avatarUrl?: Maybe<Scalars['String']>;
  azureId?: Maybe<Scalars['String']>;
  classroomEnrollments?: Maybe<Array<UserClassroomEnrollment>>;
  classroomPrivileges?: Maybe<Array<UserClassroomPrivileges>>;
  dateCreated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  externalId?: Maybe<ExternalId>;
  firstName: Scalars['String'];
  id: Scalars['Int'];
  lastName: Scalars['String'];
  licenseUsage?: Maybe<Array<UserLicenseUsage>>;
  licenses?: Maybe<Array<License>>;
  mastercodes?: Maybe<Array<Mastercode>>;
  orders?: Maybe<Array<Order>>;
  organizationAssociations?: Maybe<Array<UserOrganization>>;
  organizationPrivileges?: Maybe<Array<UserOrganizationPrivileges>>;
  pin: Scalars['String'];
  settings?: Maybe<Array<UserSetting>>;
  sisId?: Maybe<Scalars['String']>;
  status: UserStatus;
  toursSettings?: Maybe<Array<TourSettings>>;
  trialUsage?: Maybe<Array<UserTrialUsage>>;
  type: UserType;
  userTypeId: Scalars['Int'];
  username: Scalars['String'];
};

export type UserLicenseUsageArgs = {
  where?: InputMaybe<UserLicenseUsageWhereInput>;
};

export type UserLicensesArgs = {
  orderBy?: InputMaybe<LicensesOrderInput>;
  where?: InputMaybe<LicensesWhereInput>;
};

export type UserMastercodesArgs = {
  orderBy?: InputMaybe<MastercodesOrderInput>;
  where?: InputMaybe<MastercodesWhereInput>;
};

export type UserOrdersArgs = {
  orderBy?: InputMaybe<OrdersOrderInput>;
  where?: InputMaybe<OrdersWhereInput>;
};

export type UserSettingsArgs = {
  orderBy?: InputMaybe<UserSettingsOrderInput>;
  where?: InputMaybe<UserSettingsWhereInput>;
};

export type UserToursSettingsArgs = {
  where?: InputMaybe<ToursSettingsWhereInput>;
};

export type UserTrialUsageArgs = {
  where?: InputMaybe<UserLicenseUsageWhereInput>;
};

export type UserClassroomEnrollment = {
  __typename?: 'UserClassroomEnrollment';
  classroom: Classroom;
  classroomId: Scalars['Int'];
  classroomRoleIds: Array<Scalars['Int']>;
  classroomRoles: Array<ClassroomRole>;
  user: User;
  userId: Scalars['Int'];
};

export type UserClassroomPrivileges = {
  __typename?: 'UserClassroomPrivileges';
  classroomId: Scalars['Int'];
  privileges?: Maybe<Array<Scalars['String']>>;
};

export type UserCreateInput = {
  avatarUrl?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<ExternalIdInput>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  licenses?: InputMaybe<Array<CreateEntityLicenseAssignInput>>;
  organizationAssociations?: InputMaybe<Array<UserOrganizationInput>>;
  pin?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Array<BaseSettingCreateInput>>;
  sisId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UserStatus>;
  type?: InputMaybe<UserType>;
  username: Scalars['String'];
};

export type UserEnrollmentInput = {
  classroomRole?: InputMaybe<Array<UserRole>>;
  userId: Scalars['Int'];
};

export type UserLicenseUsage = {
  __typename?: 'UserLicenseUsage';
  active: Scalars['Boolean'];
  assignedCount: Scalars['Int'];
  manualAssignment: Scalars['Boolean'];
  product: Product;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productId: Scalars['Int'];
  trial: Scalars['Boolean'];
};

export type UserLicenseUsageWhereInput = {
  includeExpired?: InputMaybe<Scalars['Boolean']>;
  product?: InputMaybe<Array<ProductIdentifierInput>>;
  productCurriculum?: InputMaybe<Array<ProductIdentifierInput>>;
  productFamily?: InputMaybe<Array<ProductIdentifierInput>>;
};

export enum UserOrderField {
  FIRST_NAME = 'FIRST_NAME',
  ID = 'ID',
  LAST_NAME = 'LAST_NAME',
  SOURCE_ID = 'SOURCE_ID',
  SOURCE_KIND_ID = 'SOURCE_KIND_ID',
  USERNAME = 'USERNAME',
}

export type UserOrganization = {
  __typename?: 'UserOrganization';
  organization: Organization;
  organizationId: Scalars['Int'];
  organizationRoleIds: Array<Scalars['Int']>;
  organizationRoles: Array<OrganizationRole>;
  user: User;
  userId: Scalars['Int'];
};

export type UserOrganizationInput = {
  organizationId: Scalars['Int'];
  organizationRoleId: Array<Scalars['Int']>;
};

export type UserOrganizationPrivileges = {
  __typename?: 'UserOrganizationPrivileges';
  organizationId: Scalars['Int'];
  privileges?: Maybe<Array<Scalars['String']>>;
};

export type UserOrganizationWhereInput = {
  excludeAncestors?: InputMaybe<Scalars['Boolean']>;
};

export enum UserRole {
  COEDUCATOR = 'COEDUCATOR',
  COEDUCATOR_GSS = 'COEDUCATOR_GSS',
  COEDUCATOR_KEY = 'COEDUCATOR_KEY',
  EDUCATOR = 'EDUCATOR',
  EDUCATOR_GSS = 'EDUCATOR_GSS',
  EDUCATOR_KEY = 'EDUCATOR_KEY',
}

export enum UserSearchField {
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
  USERNAME = 'USERNAME',
}

export type UserSetting = {
  __typename?: 'UserSetting';
  app: App;
  appId: Scalars['Int'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  id: Scalars['Int'];
  product?: Maybe<Product>;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  setting: Scalars['String'];
  user: User;
  userId: Scalars['Int'];
  value: Scalars['JSON'];
};

export type UserSettingCreateInput = {
  appId?: InputMaybe<Scalars['Int']>;
  appName?: InputMaybe<Scalars['String']>;
  productCode?: InputMaybe<Scalars['String']>;
  productCurriculumCode?: InputMaybe<Scalars['String']>;
  productCurriculumId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  setting: Scalars['String'];
  userId: Scalars['Int'];
  value: Scalars['JSON'];
};

export enum UserSettingOrderField {
  APP_ID = 'APP_ID',
  PRODUCT_CURRICULUM_ID = 'PRODUCT_CURRICULUM_ID',
  PRODUCT_ID = 'PRODUCT_ID',
  SETTING = 'SETTING',
  USER_ID = 'USER_ID',
}

export type UserSettingUpdateInput = {
  appId?: InputMaybe<Scalars['Int']>;
  setting?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type UserSettingWhereInput = {
  appId?: InputMaybe<Scalars['Int']>;
  appName?: InputMaybe<Scalars['String']>;
  productCode?: InputMaybe<Scalars['String']>;
  productCurriculumCode?: InputMaybe<Scalars['String']>;
  productCurriculumId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  setting: Scalars['String'];
  userId: Scalars['Int'];
};

export type UserSettingsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<UserSettingOrderField>;
};

export type UserSettingsUpdateInput = {
  appId?: InputMaybe<Scalars['Int']>;
  setting?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type UserSettingsWhereInput = {
  appId?: InputMaybe<Array<Scalars['Int']>>;
  appName?: InputMaybe<Array<Scalars['String']>>;
  productCode?: InputMaybe<Array<Scalars['String']>>;
  productCurriculumCode?: InputMaybe<Array<Scalars['String']>>;
  productCurriculumId?: InputMaybe<Array<Scalars['Int']>>;
  productId?: InputMaybe<Array<Scalars['Int']>>;
  setting?: InputMaybe<Array<Scalars['String']>>;
  userId?: InputMaybe<Array<Scalars['Int']>>;
};

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
}

export type UserTrialUsage = {
  __typename?: 'UserTrialUsage';
  active: Scalars['Boolean'];
  available: Scalars['Boolean'];
  dateExpiration?: Maybe<Scalars['DateTime']>;
  product: Product;
  productCurriculum: ProductCurriculum;
  productCurriculumId: Scalars['Int'];
  productId: Scalars['Int'];
};

export enum UserType {
  ADMINISTRATOR = 'ADMINISTRATOR',
  CURRICULUM = 'CURRICULUM',
  ESL_ESOL = 'ESL_ESOL',
  HOMESCHOOL_EDUCATOR = 'HOMESCHOOL_EDUCATOR',
  K5_TEACHER = 'K5_TEACHER',
  OCCUPATIONAL_THERAPIST = 'OCCUPATIONAL_THERAPIST',
  OTHER = 'OTHER',
  PARENT_FAMILY = 'PARENT_FAMILY',
  PREK_TEACHER = 'PREK_TEACHER',
  PRINCIPAL_VICE_PRINCIPAL = 'PRINCIPAL_VICE_PRINCIPAL',
  READING_SPECIALIST = 'READING_SPECIALIST',
  SPECIAL_EDUCATION = 'SPECIAL_EDUCATION',
  TECHNOLOGY_MEDIA = 'TECHNOLOGY_MEDIA',
}

export type UserUpdateInput = {
  avatarUrl?: InputMaybe<Scalars['String']>;
  dateRemoved?: InputMaybe<Scalars['DateTime']>;
  externalId?: InputMaybe<ExternalIdUpdateInput>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  organizationAssociations?: InputMaybe<Array<UserOrganizationInput>>;
  pin?: InputMaybe<Scalars['String']>;
  sisId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UserStatus>;
  type?: InputMaybe<UserType>;
  username?: InputMaybe<Scalars['String']>;
};

export type UserWhereInput = {
  externalId?: InputMaybe<ExternalIdInput>;
  id?: InputMaybe<Scalars['Int']>;
  pin?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type UsersOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<UserOrderField>;
};

export type UsersUpdateInput = {
  dateRemoved?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<UserStatus>;
};

export type UsersWhereInput = {
  AND?: InputMaybe<Array<UsersWhereInput>>;
  OR?: InputMaybe<Array<UsersWhereInput>>;
  firstName?: InputMaybe<Array<Scalars['String']>>;
  firstName_contains?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  includeRemoved?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Array<Scalars['String']>>;
  lastName_contains?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
  organizationRoles?: InputMaybe<OrganizationRolesWhereInput>;
  organizations?: InputMaybe<OrganizationsWhereInput>;
  pin?: InputMaybe<Array<Scalars['String']>>;
  removed?: InputMaybe<Scalars['Boolean']>;
  sisId?: InputMaybe<Array<Scalars['String']>>;
  sourceId?: InputMaybe<Array<Scalars['String']>>;
  sourceKind?: InputMaybe<Array<SourceKind>>;
  status?: InputMaybe<Array<UserStatus>>;
  type?: InputMaybe<Array<UserType>>;
  username?: InputMaybe<Array<Scalars['String']>>;
  username_contains?: InputMaybe<Scalars['String']>;
};

export type ViewTabEventCreateInput = {
  section: ApplicationSection;
  tab: ApplicationTab;
  timestamp: Scalars['DateTime'];
};

export type WordInput = {
  description: Scalars['String'];
  wordId: Scalars['Int'];
};
